<template>
  <div class="sigleproduct">
    <!-- <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading> -->
    <CommonHead></CommonHead>
    <b-modal
      id="recolor_new_notificaion"
      ref="recolormodal"
      title=""
      title-tag="h3"
      ok-only
      modal-class="common_pop"
    >
    <p class="pb-4">If you want to make edits in your existing designed pattern, please close this window, select the order type and base fabric and save your customized pattern to a project by clicking on the "Save to Projects" button.</p>
    <p class="pb-4">If you want to start with the new design, please proceed further by clicking on the button below.</p>
    <a v-if="hasRecolors" :href="hasRecolors.LINK" target="_blank" class="btn btn-dark btn-block">Start New Design in Recolor Session</a>
    </b-modal>
    
    <b-modal
      id="recolor_memo_notificaion"
      ref="recolor_memo_notificaion_modal"
      title=""
      title-tag="h3"
      ok-only
      modal-class="common_pop">
    <p class="pb-4">Memo's are not available for Customized fabrics. Order type will be changed to Regular with a minimum quantity of 1 yard.</p>
    <p class="pb-4">Do you wish to continue?</p>
    <a v-if="hasRecolors" @click="redirectRecolor" class="btn btn-dark btn-block">Yes</a>
    <a @click="hideModal" class="btn btn-dark btn-block">No</a>
    </b-modal>

    <b-modal
      id="cart_notificaion"
      ref="cartmodal"
      :title="this.cartOrderMsg"
      title-tag="h3"
      ok-only
      modal-class="common_pop cart_notificaion"
    ></b-modal>

    <b-modal
      id="success-save-project"
      ref="successmodal"
      :title="this.successtitle"
      title-tag="h3"
      ok-only
      modal-class="common_pop save_project">
    </b-modal>

    <!-- Save to projects pop up -->
    <b-modal
      id="saveto-project"
      ref="modal"
      title="Save to Projects"
      title-tag="h3"
      ok-only
      modal-class="common_pop saveto_project">
      <div v-if="!showclient && !shownewproject && !shownewclient" class="projectoptions">
        <h3>Save to Projects</h3>
        <ul>
          <li>
            <a
              href="javascript:;"
              @click="showclient = !showclient"
            >Existing Client - Existing Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewproject = !shownewproject"
            >Existing Client - New Project</a>
          </li>
          <li>
            <a
              href="javascript:;"
              @click="shownewclient = !shownewclient"
            >New Client- New Project</a>
          </li>
        </ul>
      </div>
      <div v-if="showclient" class="savetoclient">
        <a @click="(showclient = !showclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to Existing Client- Project</h3>
        <b-form class="commonform" @submit="Submit1Popup">
          <div class="row">
            <div
              class="col"
              :state="!form1.errors.has('client')"
              :class="form1.errors.get('client')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('client')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('client')"
                  @input="form1.errors.clear('client'); getProjects();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form1.client"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('client')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject">
            <div
              class="col"
              :state="!form1.errors.has('project')"
              :class="form1.errors.get('project')?'haserror forstar':'forstar'"
              :invalid-feedback="form1.errors.get('project')"
            >
              <label class="setuplabel">Select a Project</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form1.errors.has('project')"
                  @input="form1.errors.clear('project')"
                  :options="projects"
                  :reduce="projects => projects.value"
                  label="text"
                  v-model="form1.project"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form1.errors.get('project')">Required Field</span>
              </div>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form1.error_name!=''">{{this.form1.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewproject" class="savetoclient">
        <a @click="(shownewproject = !shownewproject); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Project of Existing Client</h3>
        <b-form class="commonform" @submit="Submit2Popup">
          <div class="row">
            <div
              class="col"
              :state="!form2.errors.has('client_id')"
              :class="form2.errors.get('client_id')?'haserror forstar':'forstar'"
              :invalid-feedback="form2.errors.get('client_id')"
            >
              <label class="setuplabel">Select a Client</label>
              <div class="md-field md-theme-default">
                <v-select
                  :state="!form2.errors.has('client_id')"
                  @input="form2.errors.clear('client_id'); showProject1();"
                  :options="clientscart"
                  :reduce="clientscart => clientscart.value"
                  label="text"
                  v-model="form2.client_id"
                  placeholder
                ></v-select>
                <span class="error-msg" v-if="form2.errors.get('client_id')">Required Field</span>
              </div>
            </div>
          </div>
          <div class="row showProject1">
            <div class="col">
              <md-field
                :state="!form2.errors.has('name')"
                :class="form2.errors.get('name')?'haserror forstar':'forstar'"
                :invalid-feedback="form2.errors.get('name')"
              >
                <label class="setuplabel">Create and save to new project</label>
                <md-input
                  :state="!form2.errors.has('name')"
                  @input="form2.errors.clear('name')"
                  v-model="form2.name"
                ></md-input>

                <span
                  class="error-msg"
                  v-if="form2.errors.get('name')"
                >{{form2.errors.get('name')=="The name field is required."?'Required Field':form2.errors.get('name')}}</span>
              </md-field>
            </div>
          </div>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form2.error_name!=''">{{this.form2.error_name}}</span>
        </b-form>
      </div>
      <div v-if="shownewclient" class="savetoclient newcreation">
        <a @click="(shownewclient = !shownewclient); resetModelForm();" href="javascript:;">
          <b-img class="slidearrow" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img>Back
        </a>
        <h3>Save to New Client- Project</h3>
        <b-form class="commonform" @submit="Submit3Popup">
          <md-field
            :state="!form.errors.has('createclient')"
            :class="form.errors.get('createclient')?'haserror forstar':'forstar'"
            :invalid-feedback="form.errors.get('createclient')"
          >
            <label>Create a new client</label>
            <md-input
              :state="!form.errors.has('createclient')"
              @input="form.errors.clear('createclient'); showProject2();"
              v-model="form.createclient"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createclient')"
            >{{form.errors.get('createclient')=="The createclient field is required."?'Required Field':form.errors.get('createclient')}}</span>
          </md-field>
          <md-field
            :state="!form.errors.has('createproject')"
            :class="form.errors.get('createproject')?'haserror forstar showProject2':'forstar showProject2'"
            :invalid-feedback="form.errors.get('createproject')"
          >
            <label>Create a new project</label>
            <md-input
              :state="!form.errors.has('createproject')"
              @input="form.errors.clear('createproject')"
              v-model="form.createproject"
            ></md-input>
            <span
              class="error-msg"
              v-if="form.errors.get('createproject')"
            >{{form.errors.get('createproject')=="The createproject field is required."?'Required Field':form.errors.get('createproject')}}</span>
          </md-field>
          <b-button block type="submit" variant="dark">Add</b-button>
          <span class="error-msg" v-if="this.form.error_name!=''">{{this.form.error_name}}</span>
        </b-form>
      </div>
    </b-modal>
    <div class="basestyle-backdrop bg-dark" v-if="basestyleshow == true" @click="closeBaseFabrics"></div>
    <div class="basestylecontainer" v-if="basestyleshow == true">
      <div class="row my-5">
        <h3 class="mx-auto pl-65 basecotainertitle">Select a Base</h3>
        <b-img
          class="mr-5 basestylecontainer-close-icon"
          src="/shop/images/close.svg"
          fluid
          alt="close image"
          @click="closeBaseFabrics"
        ></b-img>
      </div>
      <perfect-scrollbar :suppressScrollX="false">
        <SKLoader :repeat="5" :loading="isLoadingBase" speed="1s" class="baseloadercont">
          <SKBaseFabrics/>
        </SKLoader>
        <template v-if="baseFabrics.length > 0 && isLoadingBase == false">
          <template>
            <div v-for="(baseFabric, i) in baseFabrics" class="p-3" :key="i">
              <div class="row mb-5">
                <div class="col-5">
                  <b-img :src="baseFabric.URL" fluid></b-img>
                </div>
                <div class="col-7">
                  <h3 class="text-left mb-3 basefabricname">
                    {{ baseFabric.NAME }}
                  </h3>
                  <p>Price: 
                    <span class="font-weight-normal">
                      $ {{ parseFloat(baseFabric.AMOUNT).toFixed(2) }} / per yd
                    </span>
                  </p>
                  <p class="basefabricdescrip">{{ baseFabric.RMC_BaseFabricDesc }}</p>
                  <hr>
                  <div class="accordion">
                    <a class="text-decoration-none" href="javascript:;" v-b-toggle="'collapse-' + i">
                      Specifications
                    </a>
                    <div class="specification mt-3">
                      <div class="spec_cont">
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Width:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWidth != '' ? parseFloat(baseFabric.RMC_BaseFabricWidth).toFixed(2) : "-" }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Weight:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWeight != '' ? parseFloat(baseFabric.RMC_BaseFabricWeight).toFixed(2) : '' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Content:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricContent != '' ? baseFabric.RMC_BaseFabricContent : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Country:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.LogisticsAddressCountryRegionId != '' ? baseFabric.LogisticsAddressCountryRegionId : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Wyzenbeek:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricWyzenbeek != '' ? baseFabric.RMC_BaseFabricWyzenbeek : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Martindale:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.RMC_BaseFabricMartindale != '' ? baseFabric.RMC_BaseFabricMartindale : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>CleaningCode:</span>
                          </div>
                          <div class="txtspec">
                            <p>{{ baseFabric.CleaningCode != '' ? baseFabric.CleaningCode : '-' }}</p>
                          </div>
                        </div>
                        <div class="spec_details">
                          <div class="lblspec">
                            <span>Test Code:</span>
                          </div>
                          <div class="txtspec">
                            <p>
                              {{ baseFabric.rmcFireTestCode1 != '' ? baseFabric.rmcFireTestCode1 : '-' }},
                              {{ baseFabric.rmcFireTestCode2 != '' ? baseFabric.rmcFireTestCode2 : '-' }},
                              {{ baseFabric.rmcFireTestCode3 != '' ? baseFabric.rmcFireTestCode3 : '-' }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <button class="btn btn btn-outline-primary fabricSelectBtn" @click="baseFabricSelected(baseFabric)">SELECT</button>
                </div>
              </div>
              <hr>
            </div>
            <p v-if="cartform.order_type.toLowerCase() == 'memo'">If you would like a different base fabric, change the order type to Regular for 1 yard and then select your fabric from there.</p>
          </template>
        </template>
        <template v-else>
          <div class="text-center">
            <h3 class="mt-5">No Fabric Found. </h3>
          </div>
        </template>
      </perfect-scrollbar>
    </div>
    <div class="container">
      <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
      <SKLoader
        :repeat="1"
        :loading="isLoading"
        speed="1s"
        >
        <SKProductDetails/>
      </SKLoader>
      <div class="singleproductdetails" v-if="isLoading == false">
	  <div class="mobile-title">
		<h2>{{info.ITEMNAME}} / {{info.COLORNAME}}</h2>
          <a v-if="user.id > 0" class="printdetails" @click="getPDF()" href="javascript:;">
            <b-img class="print" src="/shop/images/print.svg" fluid alt="print image"></b-img>Print Details
          </a>
	  </div>
        <div class="singleimage">
          <div class="positionset">
            <div class="highlight">
              <span v-if="(info.ABCCODEVALUEREF != 'A' && info.ABCCODEVALUEREF != 'B' && info.ABCCODEVALUEREF != 'C' && info.ABCCODEVALUEREF != 'D' && info.ABCCODEVALUEREF != 'E' && info.ABCCODEVALUEREF != 'F'  && info.ABCCODEVALUEREF != 'X' && info.ABCCODEVALUEREF != 'L') && info.DISCOUNTPRICE > 0" class="saletag">Sale</span>
              <vue-magnifier
                :src="info.SRCSMALL"
                :src-large="info.SRCLARGE"
              />
              <a
                :href="info.SRCLARGE"
                :download="info.ITEMNAME+'-'+info.COLORNAME+'.jpg'"
                class="downloadimg"
                v-b-tooltip.hover
                title="Download Image"
              >
                <b-img class="download" src="/shop/images/download.svg" fluid alt="download image"></b-img>
              </a>
              <div v-if="info.RMCRAILROADED == 1" class="railroadtag">Woven Railroaded, Shown Turned</div>
            </div>
            <div class="smallimages" v-if="info.PRODUCTIMAGES.length > 1">
              <a
                v-for="(proimg,pik) in info.PRODUCTIMAGES"
                :key="pik"
                href="javascript:;"
                class="forborder"
                @click="changeimagesrc(proimg)"
              >
                <b-img class="smallimg" :src="proimg.MEDIUM_IMAGE" fluid alt="product6 image"></b-img>
              </a>
            </div>
          </div>
        </div>
        <div class="singlecontent">
          <h2>{{info.ITEMNAME}} / {{info.COLORNAME}}</h2>
          <h3 v-if="info.DESIGN_NAME">"{{info.DESIGN_NAME}}"</h3>
          <h3 v-if="info.TYPES && !info.DESIGN_NAME">{{info.TYPES}}</h3>
          <a v-if="user.id > 0" class="printdetails" @click="getPDF()" href="javascript:;">
            <b-img class="print" src="/shop/images/print.svg" fluid alt="print image"></b-img>Print Details
          </a>
          <div class="pricesection" v-if="user.id > 0 && info.COLORWORKS != '1'">
            <div class="samediv">
              <span>Retail Price :</span>
              <p>$ {{parseFloat(info.PRICE * 2).toFixed(2)}} / {{info.UNITID}}</p>
            </div>
            <div class="samediv" v-if="user.setting_retail === false">
              <span>Wholesale Price :</span>
              <div v-if="info.DISCOUNTPRICE > 0 && info.CUSTOMERDISCOUNT == false">
                <p
                  class="regprice"
                >$ {{parseFloat(info.PRICE).toFixed(2)}} / {{info.UNITID}}</p>
                <span
                  class="saleprice"
                >$ {{parseFloat(info.DISCOUNTPRICE).toFixed(2)}} / {{info.UNITID}}</span>
              </div>
              <p v-else-if="info.DISCOUNTPRICE == 0">$ {{parseFloat(info.PRICE).toFixed(2)}} / {{info.UNITID}}</p>
              <p v-else-if="info.CUSTOMERDISCOUNT == true">$ {{parseFloat(info.PRICE).toFixed(2)}} / {{info.UNITID}}</p>
            </div>
            <div class="samediv" v-if="info.SUNTAFITEMSTATUS != 'DropShip'">
              <span>Qty on Hand :</span>
              <p>{{info.QTYONHAND}} {{info.UNITID}}</p>
            </div>
            <div class="samediv" v-if="info.ITEMGROUPID == 'LN' &&  user.setting_retail === false">
              <p>Wholesale pricing shown is cut yardage pricing. For bolt pricing and availability, please contact Customer Service at 1-800-325-8025 or customerservice@rmcoco.com.</p>
            </div>
          </div>
        <div class="pricesection" v-if="user.id > 0 && info.COLORWORKS == '1'"> 
            <div class="samediv">
              <span>Retail Price :</span>
              <p>$ {{ computedPrice(2) }} / {{info.UNITID}}</p>
            </div>
            <div class="samediv" v-if="user.setting_retail === false">
              <span>Wholesale Price :</span>
              <p>$ {{ computedPrice() }} / {{info.UNITID}}</p>
            </div>
            <div class="samediv">
              <span>Total Qty on Hand: </span>
              <p class="d-flex">
                Custom printed in the USA by
                <b-img
                  class="d-inline color-works-image"
                  src="/shop/images/colorworks_black.svg"
                  fluid
                  alt="colorworks"
                ></b-img> 
              </p>
            </div>
        </div> 
		  <div class="detailed-options">
			  <ul class="new_ul">
				 <li v-if="info.HTMLBOLTS.length>0 && user.id"><a href="javascript:;" v-b-toggle.available-bolts>Available Bolts <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
					<b-collapse id="available-bolts" accordion="my-accordion">
						<div class="specification">
							<div class="spec_cont">
							  <div class="spec_details">
								<span class="lblspec">Bolt</span>
								<p class="txtspec">Qty on hand</p>
							  </div>
							  <div
								class="spec_details"
								v-for="(result, index) in info.HTMLBOLTS"
								:key="index"
							  >
								<span class="lblspec">{{result.bolt}}</span>
								<p class="txtspec">{{result.qty}}</p>
							  </div>
							</div>
						  </div>
					</b-collapse>
				</li>
				<li class="diff_li">
					<div class="fixedbar">
						  <div class="container">
							<div class="beforesignin" v-if="user.id<=0">
							  <h3>To place orders please sign in or register</h3>
							  <div class="buttonsdiv">
								  <b-button href="/shop/login" variant="dark">Sign in</b-button>
								  <b-button href="/apply/" variant="dark">Register</b-button>
							  </div>
							</div>
							<b-form class="addcartform commonform" @submit="onSubmit" v-if="user.id >0">
							  <div class="afterlogin">
                <p v-if="isDiscontinued == false && info.COLORWORKS == '0'" :class="(info.QTYONHAND>1 || info.SUNTAFITEMSTATUS == 'DropShip')?'noti_msg HideNoti':'noti_msg'">Your order will be backordered due the quantity on hand. See Available Bolts for details.</p>
                <p v-if="isDiscontinued == true" :class="(info.QTYONHAND>1)?'noti_msg HideNoti':'noti_msg'">Selected order quantity is not available.</p>
								<div
								  class="ordertype type"
								  :state="!cartform.errors.has('order_type')"
								  :class="cartform.errors.get('order_type')?'haserror forstar':'forstar'"
								  :invalid-feedback="cartform.errors.get('order_type')"
								>
								  <v-select
									:options="orderstype"
									v-model="cartform.order_type"
									@input="cartform.errors.clear('order_type'); CheckCartOrderType();"
									:reduce="orderstype => orderstype.value"
									label="text"
									:clearable="false"
									:searchable="false"
									:state="!cartform.errors.has('order_type')"
									placeholder="Please Select Order Type"
								  ></v-select>
								  <!--<span class="error-msg" v-if="cartform.errors.get('order_type')">Required Field</span>-->
								</div>
								<div class="samediv quantity">
								  <div class="qtydiv">
									<span @click="decrement()">-</span>
									<input v-model.number="cartform.quantity" type="number" @input="handleInput" step=".01"/>
									<span v-if="isDiscontinued == true && (Number(info.QTYONHAND) < Number(cartform.quantity))" class="lastspan">+</span>
									<span v-else @click="increment()" class="lastspan">+</span>
								  </div>
								</div>
								<div class="ordertype yard">
								  <v-select
									:options="yard"
									v-model="cartform.unitid"
									:clearable="false"
									:searchable="false"
									placeholder="yd"
								  ></v-select>
								</div>
                <div class="requiredcut bsbox" v-if="user.id > 0">
								  <input v-if="info.COLORWORKS == '1'" :disabled="cartform.order_type == ''" class="basestyle" type="text" :value="basefabricname" readonly @click="getBaseFabrics" placeholder="Please Select Base" />
                  <span v-if="info.COLORWORKS == '1'" class="error-msg basestyle-error d-none">Required Field</span>
                  <span v-if="basefabricname" class="blue-msg">Can be changed any time prior to fabric purchase.</span>
                  <img v-if="info.COLORWORKS == '1'" src="/shop/images/edit.svg" alt="Edit image" class="edit-alt" @click="getBaseFabrics">
                  <input type="text" v-model="cartform.notes" :class="info.COLORWORKS == '1'?'cartformnotes bsstyle':'cartformnotes'" placeholder="Required Cuts if known:" />
								</div>
                <div v-if="(info.ITEMGROUPID.startsWith('T') === true) && (info.UNITID.toLowerCase() == 'ea')" class="trim_t_info">For a color sample, please contact customer service at 800-325-8025</div>
								<div class="requiredcut basefabricimg" v-if="basefabricname != ''">
                  <img :src="basefabricimage" alt="Edit image" class="img-fluid">
								</div>
								<div class="barbuttons">
								  <input type="hidden" v-model="cartform.user_id" />
								  <input type="hidden" v-model="cartform.itemid" />
								  <input type="hidden" v-model="cartform.pc_type" />
								  <input type="hidden" v-model="cartform.inventcolorid" />
                  <b-button v-if="isDiscontinued && info.QTYONHAND < 1" type="button" class="AddTOCartBtn" variant="dark" disabled>Out of Stock</b-button>
								  <b-button v-else type="submit" class="AddTOCartBtn" variant="dark">Add to cart</b-button>
								  <b-button v-if="isHoldforTenAllowed == true" @click="Showsavetoproject" variant="outline-primary" :disabled="isDiscontinued && info.QTYONHAND < cartform.quantity">
                    <b-img class="saveproject" src="/shop/images/bookmark.svg" fluid alt="save image"></b-img>
                    <b-img
                      class="saveproject white"
                      src="/shop/images/bookmark-white.svg"
                      fluid
                      alt="save image"
                    ></b-img>Save to Projects
								  </b-button>
								</div>
                <p v-if="info.COLORWORKS == '1'" class="noti_msg_btm">Custom printed fabrics typically ship within 7 business days. All sales are final. Returns will only be granted for flawed or damaged goods. To learn more about ColorWorks&trade; custom digital printing <a href="/colorworks">click here.</a></p>
                <a href="javascript:;" v-if="info.COLORWORKS == '1' && hasRecolors" class="cwsampledeck" @click="editRecolor"><b-img src="/shop/images/ColorWorks Customize Web Banner.png" fluid alt="ColorWorks Sample deck image"></b-img></a>
                <!-- <a href="javascript:;" v-if="info.COLORWORKS == '1' && hasRecolors && info.INVENTCOLORID == '99'" v-b-modal.recolor_new_notificaion class="cwsampledeck"><b-img src="/shop/images/ColorWorks Customize Web Banner.png" fluid alt="ColorWorks Sample deck image"></b-img></a> -->
							  </div>
							</b-form>
						  </div>
						</div>
				</li>
        <li v-if="info.LONGDESCRIPTION"><a href="javascript:;" v-b-toggle.descriptioncont>Description <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
          <b-collapse id="descriptioncont" visible accordion="my-accordion_descriptioncont">
            <div class="specification">
							<div class="spec_cont">
                <div class="spec_details">
                  <div class="txtspec w-100"><p>{{info.LONGDESCRIPTION}}</p></div>
							  </div>
							</div>
            </div>
          </b-collapse>
        </li>
				<li><a href="javascript:;" v-b-toggle.specifications>Specifications <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
					<b-collapse id="specifications" visible accordion="my-accordion_specifications">
						<div class="specification">
							<div class="spec_cont">
							  <div class="spec_details">
                  <div class="lblspec"><span>Book / Swatch:</span></div>
                  <div class="txtspec">
                    <p v-for="(BS,BSI) in info.BOOKNSWATCH" :key="BSI">{{BS}}</p>
                  </div>
							  </div>
                <div class="spec_details" v-if="info.RMCWORKROOMPRICECODE">
                  <div class="lblspec"><span>Workroom Price Code:</span></div>
                  <div class="txtspec"><p>{{info.RMCWORKROOMPRICECODE}}</p></div>
							  </div>
							  <div class="spec_details" v-if="info.RMCFIBCONT">
                  <div class="lblspec"><span>Fiber Content:</span></div>
                  <div class="txtspec"><p>{{info.RMCFIBCONT}}</p></div>
							  </div>
							  <div class="spec_details" v-if="info.ITEMATTRIBUTEDESC">
                  <div class="lblspec"><span>Cleaning Code:</span></div>
                  <div class="txtspec"><p>{{info.ITEMATTRIBUTEDESC}}</p></div>
							  </div>
							  <div class="spec_details" v-if="info.RMCWIDTH>0">
                  <div class="lblspec"><span>Width:</span></div>
                  <div class="txtspec"><p>{{parseFloat(info.RMCWIDTH).toFixed(2)}}"</p></div>
							  </div>
                <div class="spec_details" v-if="info.RMCWIDTHFINISHED>0">
                  <div class="lblspec"><span>Embroidery/Finished Width:</span></div>
                  <div class="txtspec"><p>{{parseFloat(info.RMCWIDTHFINISHED).toFixed(2)}}"</p></div>
							  </div>
							  <div
								class="spec_details"
								v-if="info.RMCVREPEAT && info.RMCVREPEAT>0"
							  >
                  <div class="lblspec"><span>Vertical Repeat:</span></div>
                  <div class="txtspec"><p>{{parseFloat(info.RMCVREPEAT).toFixed(2)}}"</p></div>
							  </div>
							  <div
								class="spec_details"
								v-if="info.RMCHREPEAT && info.RMCHREPEAT>0"
							  >
                  <div class="lblspec"><span>Horizontal Repeat:</span></div>
                  <div class="txtspec"><p>{{parseFloat(info.RMCHREPEAT).toFixed(2)}}"</p></div>
							  </div>
							  <div class="spec_details">
                  <div class="lblspec"><span>Woven Railroaded,<br/>Shown Turned:</span></div>
                  <div class="txtspec"><p>{{info.RMCRAILROADED==0?'No':'Yes'}}</p></div>
							  </div>
							  <div
								class="spec_details"
								v-if="info.RMCMARTINRES || info.RMCWYZENRES"
							  >
                <div class="lblspec"><span>Durability:</span></div>
                  <div class="txtspec">
                    <p v-if="info.RMCMARTINRES">Martindale: {{info.RMCMARTINRES}}</p>
                    <p v-if="info.RMCWYZENRES">Wyzenbeek: {{info.RMCWYZENRES}}</p>
                  </div>
							  </div>
							  <div class="spec_details firediv" v-if="info.FIRE_RETARDANCY.length>0">
								  <div class="lblspec"><span>Fire Retardancy:</span></div>
                  <div class="txtspec">
                    <div
                      class="firelist"
                      v-for="(list, index) in info.FIRE_RETARDANCY"
                      :key="index"
                    >
                      <div class="firename">{{list.FIRETESTSCODE}}</div>
                      <div class="firecomma" v-if="index+1 < info.FIRE_RETARDANCY.length">,</div>
                    </div>
                  </div>
							  </div>
							  <div class="spec_details" v-if="info.COLOR_FASTNESS">
                  <div class="lblspec"><span>Colorfastness:</span></div>
                  <div class="txtspec"><p>{{info.COLOR_FASTNESS}}</p></div>
							  </div>
							  <div class="spec_details" v-if="info.SUNTAFGENDERVALUE">
                  <div class="lblspec"><span>Finish:</span></div>
                  <div class="txtspec"><p>{{info.SUNTAFGENDERVALUE}}</p></div>
							  </div>
                <div class="spec_details" v-if="info.COUNTRYORIGIN">
                  <div class="lblspec"><span>Country of Origin:</span></div>
                  <div class="txtspec"><p>{{info.COUNTRYORIGIN}}</p></div>
							  </div>
							  <div class="spec_details">
                  <div class="lblspec"><span>Status:</span></div>
                  <div class="txtspec">
                    <p>
                      {{info.PA}}
                      <b-img
                      v-b-tooltip.hover
                      v-if="statusTooltip(info.ABCCODEVALUEREF) != ''"
                      :title="statusTooltip(info.ABCCODEVALUEREF)"
                      class="infoimg"
                      src="/shop/images/info.svg"
                      fluid
                      alt="info image"
                      ></b-img>
                    </p>
                  </div>
							  </div>
                <div class="spec_details_flex" v-if="info.SUNTAFITEMSTATUS == 'DropShip' && info.COLORWORKS != '1'">
								  <h3>This item is dropshipped directly from mill stock.</h3>
                  <b-img
                      v-b-tooltip.hover
                      title="For the most up-to-date stock status, please contact our Customer Service team."
                      class="infoimg"
                      src="/shop/images/info.svg"
                      fluid
                      alt="info image"
                      ></b-img>
							  </div>
                <div class="spec_details" v-if="info.RMCEXCLUSIVE == '1'">
								  <h3>RM COCO EXCLUSIVE</h3>
							  </div>
							</div>
						  </div>
					</b-collapse>
				</li>
				<li><a href="javascript:;" v-b-toggle.available-color>Additional Colors <b-img class="addicon" src="/shop/images/arrow.svg" fluid alt="arrow image"></b-img></a>
					<b-collapse id="available-color" visible accordion="my-accordion_acolors">
						<div class="avail_colors smallimages">
						  <a
							:href="result.LINK"
							v-for="(result, index) in info.AVAILABLECOLORS"
							:key="index"
							:class="result.INVENTCOLORID==info.INVENTCOLORID?'forborder selected':'forborder'"
              :target="hrefTarget(result.ITEMID,result.INVENTCOLORID)"
              v-if="!(info.COLORWORKS == 1 && result.INVENTCOLORID == '99')">
							<div class="color-image">
                <b-img class="smallimg colorimg" :src="result.SMALL_IMAGE" fluid alt="color image"></b-img>
                <span class="colortag">{{result.COLORNAME}}</span>
              </div>
						  </a>
						</div>
					</b-collapse>
				</li>
			  </ul>
		  </div>
          
          
          <div class="specification">
            
            <div class="shareus">
              <p>Share:</p>
              <ul>
                <li>
                  <a :href="facebookshare" target="_blank">
                    <b-img class="social_icon" alt="facebook" src="/shop/images/facebook.svg"></b-img>
                  </a>
                </li>
                <li>
                  <a :href="pintrestshare" target="_blank">
                    <b-img class="social_icon" alt="pinterest" src="/shop/images/pinterest.svg"></b-img>
                  </a>
                </li>
                <li>
                  <a :href="houzzshare" target="_blank">
                    <b-img class="social_icon" alt="houzz" src="/shop/images/houzz.svg"></b-img>
                  </a>
                </li>
              </ul>
            </div>
            <div class="needhelp">
                <h3>Need Help?</h3>
                <div class="callwrite">
                    <div class="callus">
                    <h4>Call Us</h4>
                    <a href="#">
                        <b-img src="/shop/images/phone.svg"></b-img>800.325.8025 
                    </a>
                    <span>Mon - Fri 8:00 AM - 5:00 PM (CDT)</span>
                    </div>
                    <div class="writeus">
                    <h4>Write to Us</h4>
                    <a href="mailto:customerservice@rmcoco.com">
                        <b-img src="/shop/images/mail.svg"></b-img>customerservice@rmcoco.com
                    </a>
                    <span>We’ll get back to you within 24 hours.</span>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="similarcontent" v-if="loadCoordinating.products.length > 0">
        <h1>Coordinating Fabrics</h1>
        <div class="mainproducts">
            <VueSlickCarousel class="commonslider" v-bind="settings">
              <div class="productbox" v-for="(cordi, index) in loadCoordinating.products" :key="index">
                  <a
                    :href="'/shop/product/'+cordi.ITEMID+'/'+cordi.DETAIL[0].INVENTCOLORID"
                    class="imgbox"
                    :target="hrefTarget(cordi.ITEMID,cordi.DETAIL[0].INVENTCOLORID)"
                  >
                    <b-img
                      class="proimg"
                      :src="cordi.DETAIL[0].MEDIUM_IMAGE"
                      fluid
                      alt="product1 image"
                    ></b-img>
                    <b-img class="cw-overlay" v-if="cordi.DETAIL[0].COLORWORKS == 1" src="/shop/images/cw-overlay.png"></b-img>
                    <span v-if="cordi.DETAIL[0].DIFFDAYS <= 365" class="newtag">New</span>
                    <span
                      v-if="(cordi.DETAIL[0].RMCABCCODEVALUE != 'A' && cordi.DETAIL[0].RMCABCCODEVALUE != 'B' && cordi.DETAIL[0].RMCABCCODEVALUE != 'C' && cordi.DETAIL[0].RMCABCCODEVALUE != 'D' && cordi.DETAIL[0].RMCABCCODEVALUE != 'E' && cordi.DETAIL[0].RMCABCCODEVALUE != 'F' && cordi.DETAIL[0].RMCABCCODEVALUE != 'L') && cordi.DETAIL[0].DISCOUNTPRICE > 0"
                      class="saletag"
                    >Sale</span>
                  </a>
                  <div class="contentbox">
                    <div class="smallimages">
                      <a
                        v-for="(result, subindex) in cordi.DETAIL"
                        :key="subindex"
                        v-if="result.INVENTCOLORID != '99'"
                        :href="result.LINK"
                        :class="result.INVENTCOLORID==cordi.DETAIL[0].INVENTCOLORID?'forborder selected':'forborder'"
                        @mouseover="loadswatchdata(result,cordi.ITEMID,result.INVENTCOLORID,$event)"
                        :target="hrefTarget(cordi.ITEMID,result.INVENTCOLORID)"
                      >
                        <b-img class="smallimg" :src="result.SMALL_IMAGE" fluid alt="product2 image"></b-img>
                      </a>
                      <a
                        :href="'/shop/product/'+cordi.ITEMID+'/'+cordi.DETAIL[0].INVENTCOLORID"
                        class="forborder"
                        v-if="cordi.TOTALSWATCH>5"
                      >
                        <div class="moreprod">+{{cordi.TOTALSWATCH - 5}}</div>
                      </a>
                    </div>
                    <h4>
                      <a
                        href="javascript:;"
                        :target="hrefTarget(cordi.ITEMID,cordi.DETAIL[0].INVENTCOLORID)"
                      >{{cordi.ITEMNAME?cordi.ITEMNAME:''}} / <span class="clname">{{cordi.DETAIL[0].COLORNAME}}</span></a>
                    </h4>
                    <p>{{cordi.DETAIL[0].SHORTDESCRIPTION}}</p>
                    <div v-if="cordi.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0">
                      <p
                        class="regprice"
                      >${{parseFloat(cordi.DETAIL[0].PRICE).toFixed(2)}} / {{cordi.DETAIL[0].UNITID}}</p>
                      <span
                        class="saleprice"
                      >${{parseFloat(cordi.DETAIL[0].DISCOUNTPRICE).toFixed(2)}} / {{cordi.DETAIL[0].UNITID}}</span>
                    </div>
                    <p
                      v-else-if="(user.id > 0 && cordi.DETAIL[0].DISCOUNTPRICE == 0) && cordi.DETAIL[0].COLORWORKS != '1'"
                    >${{parseFloat(cordi.DETAIL[0].PRICE).toFixed(2)}} / {{cordi.DETAIL[0].UNITID}}</p>
                  </div>
                </div>
              <template #prevArrow="arrowOption">
                <div class="custom-arrow">{{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}</div>
              </template>
              <template #nextArrow="arrowOption">
                <div class="custom-arrow">{{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}</div>
              </template>
            </VueSlickCarousel>
        </div>
      </div>
      <div class="similarcontent similarfabric" v-if="similarproducts.products.length>0">
        <h1 v-if="info.PRODUCTTYPE == 'Fabric'">Similar Fabrics</h1>
        <h1 v-else>Similar Trim</h1>
        <div class="mainproducts">
            <VueSlickCarousel class="commonslider" v-bind="settings">
              <div class="productbox" v-for="(similar, index) in similarproducts.products" :key="index">
                  <a
                    :href="'/shop/product/'+similar.ITEMID+'/'+similar.DETAIL[0].INVENTCOLORID"
                    class="imgbox"
                    :target="hrefTarget(similar.ITEMID,similar.DETAIL[0].INVENTCOLORID)"
                  >
                    <b-img
                      class="proimg"
                      :src="similar.DETAIL[0].MEDIUM_IMAGE"
                      fluid
                      alt="product1 image"
                    ></b-img>
                    <span v-if="similar.DETAIL[0].DIFFDAYS <= 365" class="newtag">New</span>
                    <span
                      v-if="(similar.DETAIL[0].RMCABCCODEVALUE != 'A' && similar.DETAIL[0].RMCABCCODEVALUE != 'B' && similar.DETAIL[0].RMCABCCODEVALUE != 'C' && similar.DETAIL[0].RMCABCCODEVALUE != 'D' && similar.DETAIL[0].RMCABCCODEVALUE != 'E' && similar.DETAIL[0].RMCABCCODEVALUE != 'F' && similar.DETAIL[0].RMCABCCODEVALUE != 'X' && similar.DETAIL[0].RMCABCCODEVALUE != 'L') && similar.DETAIL[0].DISCOUNTPRICE > 0"
                      class="saletag"
                    >Sale</span>
                  </a>
                  <div class="contentbox">
                    <div class="smallimages">
                      <a
                        v-for="(result, subindex) in similar.DETAIL"
                        :key="subindex"
                        v-if="result.INVENTCOLORID != '99'"
                        :href="'/shop/product/'+similar.ITEMID+'/'+result.INVENTCOLORID"
                        :class="result.INVENTCOLORID==similar.DETAIL[0].INVENTCOLORID?'forborder selected':'forborder'"
                        @mouseover="loadswatchdata(result,similar.ITEMID,result.INVENTCOLORID,$event)"
                        :target="hrefTarget(similar.ITEMID,result.INVENTCOLORID)"
                      >
                        <b-img class="smallimg" :src="result.SMALL_IMAGE" fluid alt="product2 image"></b-img>
                      </a>
                      <a
                        :href="'/shop/product/'+similar.DETAIL[0].ITEMID+'/'+similar.DETAIL[0].INVENTCOLORID"
                        class="forborder"
                        v-if="similar.DETAIL.length>5"
                      >
                        <div class="moreprod">+{{similar.DETAIL.length - 5}}</div>
                      </a>
                    </div>
                    <h4>
                      <a
                        href="javascript:;"
                        :target="hrefTarget(similar.ITEMID,similar.DETAIL[0].INVENTCOLORID)"
                      >{{similar.ITEMNAME?similar.ITEMNAME:''}} / <span class="clname">{{similar.DETAIL[0].COLORNAME}}</span></a>
                    </h4>
                    <p>{{similar.DETAIL[0].SHORTDESCRIPTION}}</p>
                    <div v-if="similar.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0">
                      <p
                        class="regprice"
                      >${{parseFloat(similar.DETAIL[0].PRICE).toFixed(2)}} / {{similar.DETAIL[0].UNITID}}</p>
                      <span
                        class="saleprice"
                      >${{parseFloat(similar.DETAIL[0].DISCOUNTPRICE).toFixed(2)}} / {{similar.DETAIL[0].UNITID}}</span>
                    </div>
                    <p
                      v-else-if="user.id > 0 && similar.DETAIL[0].DISCOUNTPRICE == 0"
                    >${{parseFloat(similar.DETAIL[0].PRICE).toFixed(2)}} / {{similar.DETAIL[0].UNITID}}</p>
                  </div>
                </div>
              <template #prevArrow="arrowOption">
                <div class="custom-arrow">{{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}</div>
              </template>
              <template #nextArrow="arrowOption">
                <div class="custom-arrow">{{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}</div>
              </template>
            </VueSlickCarousel>
        </div>
      </div>

      <div class="similarcontent recentlyview" v-if="recentproduct.products.length>0">
        <h1>Recently Viewed </h1>
        <div class="mainproducts">
          <VueSlickCarousel class="commonslider" v-bind="settings">
            <div class="productbox" v-for="(recent, index) in recentproduct.products" :key="index">
              <a
                :href="'/shop/product/'+recent.ITEMID+'/'+recent.DETAIL[0].INVENTCOLORID"
                class="imgbox"
                :target="hrefTarget(recent.ITEMID,recent.DETAIL[0].INVENTCOLORID)"
              >
                <b-img
                  class="proimg"
                  :src="recent.DETAIL[0].MEDIUM_IMAGE"
                  fluid
                  alt="product1 image"
                ></b-img>
                <b-img class="cw-overlay" v-if="recent.DETAIL[0].COLORWORKS == 1" src="/shop/images/cw-overlay.png"></b-img>
                <span v-if="recent.DETAIL[0].DIFFDAYS <= 365" class="newtag">New</span>
                <span
                  v-if="(recent.DETAIL[0].RMCABCCODEVALUE != 'A' && recent.DETAIL[0].RMCABCCODEVALUE != 'B' && recent.DETAIL[0].RMCABCCODEVALUE != 'C' && recent.DETAIL[0].RMCABCCODEVALUE != 'D' && recent.DETAIL[0].RMCABCCODEVALUE != 'E' && recent.DETAIL[0].RMCABCCODEVALUE != 'F' && recent.DETAIL[0].RMCABCCODEVALUE != 'L') && recent.DETAIL[0].DISCOUNTPRICE > 0"
                  class="saletag"
                >Sale</span>
              </a>
              <div class="contentbox">
                <div class="smallimages rcnt">
                  <a
                    v-for="(result, subindex) in recent.DETAIL"
                    :key="subindex"
                    v-if="result.INVENTCOLORID != '99'"
                    :href="result.LINK"
                    :class="result.INVENTCOLORID==recent.DETAIL[0].INVENTCOLORID?'forborder selected':'forborder'"
                    @mouseover="loadswatchdata(result,recent.ITEMID,result.INVENTCOLORID,$event)"
                    :target="hrefTarget(recent.ITEMID,result.INVENTCOLORID)"
                  >
                    <b-img class="smallimg" :src="result.SMALL_IMAGE" fluid alt="product2 image"></b-img>
                  </a>
                  <a
                    :href="'/shop/product/'+recent.ITEMID+'/'+recent.DETAIL[0].INVENTCOLORID"
                    class="forborder"
                    v-if="recent.TOTALSWATCH>5"
                  >
                    <div class="moreprod">+{{recent.TOTALSWATCH - 5}}</div>
                  </a>
                </div>
                <h4>
                  <a
                     :href="'/shop/product/'+recent.ITEMID+'/'+recent.DETAIL[0].INVENTCOLORID"
                     :target="hrefTarget(recent.ITEMID,recent.DETAIL[0].INVENTCOLORID)"
                  >{{recent.ITEMNAME?recent.ITEMNAME:''}} / <span class="clname">{{recent.DETAIL[0].COLORNAME}}</span></a>
                </h4>
                <p>{{recent.DETAIL[0].SHORTDESCRIPTION}}</p>
                <div v-if="recent.DETAIL[0].DISCOUNTPRICE > 0 && user.id > 0">
                  <p
                    class="regprice"
                  >${{parseFloat(recent.DETAIL[0].PRICE).toFixed(2)}} / {{recent.DETAIL[0].UNITID}}</p>
                  <span
                    class="saleprice"
                  >${{parseFloat(recent.DETAIL[0].DISCOUNTPRICE).toFixed(2)}} / {{recent.DETAIL[0].UNITID}}</span>
                </div>
                <p
                  v-else-if="(user.id > 0 && recent.DETAIL[0].DISCOUNTPRICE == 0) && recent.DETAIL[0].COLORWORKS != '1'"
                >${{parseFloat(recent.DETAIL[0].PRICE).toFixed(2)}} / {{recent.DETAIL[0].UNITID}}</p>
              </div>
            </div>
            <template #prevArrow="arrowOption">
              <div class="custom-arrow">{{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}</div>
            </template>
            <template #nextArrow="arrowOption">
              <div class="custom-arrow">{{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}</div>
            </template>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import { ModelSelect } from "vue-search-select";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import vueMagnifier from "@/components/vue-magnifier";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SKProductDetails from "@/views/skeletons/SKProductDetails";
import SKBaseFabrics from "@/views/skeletons/SKBaseFabrics";


export default {
  components: {
    CommonHead,
    CommonFoot,
    ModelSelect,
    vueMagnifier,
    VueSlickCarousel,
    SKProductDetails,
    SKBaseFabrics,
    "v-select": vSelect,
    Loading
  },
  mounted() {
    this.isLoading = true;
    this.$store
      .dispatch("loadProductInfo", {
        itemid: this.$route.params.itemid,
        inventcolorid: this.$route.params.inventcolorid
      })
      .then(productdetails => {
        if(productdetails.data.length > 0){
          this.productdetails = productdetails.data;
          this.info.ITEMNAME = this.productdetails[0].ITEMNAME;
          this.info.COLORNAME = this.productdetails[0].COLORNAME;
          this.info.INVENTCOLORID = this.productdetails[0].INVENTCOLORID;
          this.info.PRICE = this.productdetails[0].Price;
          this.info.UNITID = this.productdetails[0].UNITID;
          this.info.DISCOUNTPRICE = this.productdetails[0].DISCOUNTPRICE;
          this.info.CUSTOMERDISCOUNT = this.productdetails[0].CUSTOMERDISCOUNT;
          this.info.QTYONHAND = this.productdetails[0].QtyOnHand;
          this.info.HTMLBOLTS = this.productdetails[0].htmlofbolts;
          this.info.BOOKNSWATCH = this.productdetails[0].BOOKNSKU;
          this.info.RMCTAFBRANDVALUE = this.productdetails[0].RMCTAFBRANDVALUE;
          this.info.COLORWORKS = this.productdetails[0].COLORWORKS;
          this.info.RMCWORKROOMPRICECODE = this.productdetails[0].RMCWORKROOMPRICECODE;
          this.info.RMCFIBCONT = this.productdetails[0].RMCFIBCONT;
          this.info.ITEMATTRIBUTEDESC = this.productdetails[0].ITEMATTRIBUTEDESC;
          this.info.RMCWIDTH = this.productdetails[0].RMCWIDTH;
          this.info.RMCWIDTHFINISHED = this.productdetails[0].RMCWIDTHFINISHED;
          this.info.RMCVREPEAT = this.productdetails[0].RMCVREPEAT;
          this.info.RMCHREPEAT = this.productdetails[0].RMCHREPEAT;
          this.info.RMCRAILROADED = this.productdetails[0].RMCRAILROADED;
          this.info.RMCMARTINRES = this.productdetails[0].RMCMARTINRES;
          this.info.RMCWYZENRES = this.productdetails[0].RMCWYZENRES;
          this.info.FIRE_RETARDANCY = this.productdetails[0].FIRE_RETARDANCY;
          this.info.COLOR_FASTNESS = this.productdetails[0].COLOR_FASTNESS;
          this.info.SUNTAFGENDERVALUE = this.productdetails[0].SUNTAFGENDERVALUE;
          this.info.COUNTRYORIGIN = this.productdetails[0].SHORTNAME;
          this.info.LONGDESCRIPTION = this.productdetails[0].SHORTDESCRIPTION;
          this.info.RMCEXCLUSIVE = this.productdetails[0].RMCEXCLUSIVE;
          this.info.AVAILABLECOLORS = this.productdetails[0].AvailableColors;
          this.info.ABCCODEVALUEREF = this.productdetails[0].RMCABCCODEVALUE;
          if(this.info.ABCCODEVALUEREF == 'L'){
            this.info.PA = "Active - Requires minimum quantity for re-order.";
          }else{
            this.info.PA = this.productdetails[0].PA;
          }
          if(this.info.ABCCODEVALUEREF == 'X' || this.info.ABCCODEVALUEREF == 'XM' || this.info.ABCCODEVALUEREF == 'XP' || this.info.ABCCODEVALUEREF == 'Y' || this.info.ABCCODEVALUEREF == 'Z'){
            this.isDiscontinued = true;
          }else{
            this.isDiscontinued = false;
          }
          this.info.PRODUCTIMAGES = this.productdetails[0].PRODUCTIMAGES;
          this.info.SRCSMALL = this.productdetails[0].PRODUCTIMAGES[0].LARGE_IMAGE;
          this.info.SRCLARGE = this.productdetails[0].PRODUCTIMAGES[0].ORIGINAL_IMAGE;
          this.info.PRODUCTTYPE = this.productdetails[0].pc_Type;
          this.info.ITEMGROUPID = this.productdetails[0].ITEMGROUPID;
          this.info.SUNTAFITEMSTATUS = this.productdetails[0].SUNTAFITEMSTATUS;
          this.info.DESIGN_NAME = this.productdetails[0].DESIGN_NAME;
          this.info.TYPES = this.productdetails[0].TYPES;
          this.pintrestshare = 'http://pinterest.com/pin/create/button/?url='+window.location.href+'&media=//'+window.location.hostname+this.info.SRCLARGE+'&description='+this.productdetails[0].ITEMNAME + "/" + this.productdetails[0].COLORNAME;
          this.houzzshare = 'https://www.houzz.com/imageClipperUpload?link=//'+window.location.hostname+this.info.SRCLARGE+'&source=button&hzid=36769&title='+this.productdetails[0].ITEMNAME + "/" + this.productdetails[0].COLORNAME+'&ref='+window.location.href;
          this.breadcrumb[1].text = "All " + this.productdetails[0].pc_Type;
          this.breadcrumb[1].href = "/shop/products/" + this.productdetails[0].pc_Type.toLowerCase();
          this.breadcrumb[2].text = this.productdetails[0].ITEMNAME + "/" + this.productdetails[0].COLORNAME;
          this.isLoading = false;
          
          if(this.info.COLORWORKS == '1'){
            this.info.MINPRICE = this.productdetails[0].MINPRICE;
            this.info.MAXPRICE = this.productdetails[0].MAXPRICE;
            if(this.info.INVENTCOLORID == '99' || this.$route.params.itemid == 'CW001' || this.$route.params.itemid == 'CW002'){
              this.orderstype = [{ value: "regular", text: "Regular" }];
              this.cartform.recolor_id = this.productdetails[0].RECOLOR_ID;
            }else{
              this.orderstype = [{ value: "regular", text: "Regular" },{ value: "memo", text: "Memo" }];
            }
            if(this.info.RMCTAFBRANDVALUE == '2024CWDL'){
              this.orderstype = [{ value: "regular", text: "Regular" }];
            }
          }else{
            if(this.info.SUNTAFITEMSTATUS.toLowerCase()  == 'dropship'){
              this.orderstype = [{ value: "regular", text: "Regular" },{ value: "memo", text: "Memo" }];
            }
            if(this.info.ITEMGROUPID.startsWith("T") === true && this.info.UNITID.toLowerCase() == 'ea'){
              this.orderstype = [{ value: "regular", text: "Regular" },{ value: "holdtendays", text: "Hold for ten days" }];
              this.yard = ["ea"];
              this.cartform.unitid = 'ea';
            }
          }
          this.hasRecolors = this.info.AVAILABLECOLORS.find(e => e.INVENTCOLORID == '99');
          // set meta title
        if(this.productdetails[0].pc_Type=="Trim"){
          var metaTitle="RM COCO | "+this.productdetails[0].ITEMNAME+" / "+this.productdetails[0].COLORNAME+" - Decorative Fabric Trimming";
          var metaDesc="Our "+this.productdetails[0].ITEMNAME+" / "+this.productdetails[0].COLORNAME+" fabric trimming is perfect for bedding, pillows, drapery, and furniture. In stock and ready to ship.";
        }else{
          let typesformeta = this.productdetails[0].TYPES.replace(/,/g, ', ');
          let useformeta = this.productdetails[0].USES.replace(/,/g, ', '); 
          var metaTitle="RM COCO | "+this.productdetails[0].ITEMNAME+" / "+this.productdetails[0].COLORNAME+" - "+typesformeta+ " Fabric";
          var metaDesc="A "+this.productdetails[0].RMCFIBCONT+" fabric that is well-suited for "+useformeta+" projects. In stock and ready to ship.";
        }
        document.title=metaTitle;
        $('meta[name="description"]').remove();
        $('head').append('<meta name="description" content="'+metaDesc+'">');
      }else{
        this.$router.push("/shop/404");
      }
    
      });
      this.$store.dispatch("loadCoordinatingFabrics", {
        itemid: this.$route.params.itemid,
        inventcolorid: this.$route.params.inventcolorid
      }).then(loadCoordinating => {
        this.loadCoordinating = loadCoordinating.data;
      });
      // this.$store.dispatch("loadSimilarProduct", {
      //   itemid: this.$route.params.itemid,
      //   inventcolorid: this.$route.params.inventcolorid
      // })
      // .then(similarproducts => {
      //   this.similarproducts = similarproducts.data;
      // });
      if (this.user.id > 0) {
        this.$store.dispatch("loadRecentProduct", {
            itemid: this.$route.params.itemid,
            inventcolorid: this.$route.params.inventcolorid,
            customer_id: this.user.accountnumber
        }).then(recentproducts => {
          this.recentproduct = recentproducts.data;
        });
        this.LoadClients();
      };
  },
  data() {
    return {
      loadCoordinating: {
        products:[]
      },
      loadSimilar: [],
      cartOrderMsg: "",
      cartform: new Form({
        itemid: "",
        inventcolorid: "",
        pc_type: "",
        unitid: "yd",
        order_type: "",
        quantity: 1,
        notes: "",
        user_id: "",
        basestyle:"",
        recolor_id:"",
        basefabricname: "",
        baseprice:0,
        discountedprice:0
      }),
      settings: {
        dots: false,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        touchThreshold: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
            }
          }
        ],
      },
      productdetails: [],
      recentproduct: {
        products:[]
      },
      similarproducts:{
        products:[]
      },
      form: new Form({
        createclient: "",
        createproject: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        user_id: "",
        cart: "",
        error_name: "",
        inventstyleid: "",
        recolor_id:"",
        basefabricname: ""
      }),
      form1: new Form({
        client: "",
        project: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        cart: "",
        user_id: "",
        error_name: "",
        inventstyleid: "",
        recolor_id:"",
        basefabricname: ""
      }),
      form2: new Form({
        client_id: "",
        name: "",
        product_id: "",
        inventcolorid: "",
        pc_type: "",
        order_type: "",
        notes: "",
        quantity: "",
        cart: "",
        user_id: "",
        error_name: "",
        inventstyleid: "",
        recolor_id:"",
        basefabricname: ""
      }),
      minicart: {
        items: []
      },
      basefabricimage:"",
      showclient: false,
      shownewproject: false,
      shownewclient: false,
      successtitle: "",
      info:{
        ITEMNAME:"",
        COLORNAME:"",
        INVENTCOLORID:"",
        PRICE:null,
        UNITID:"",
        DISCOUNTPRICE:null,
        CUSTOMERDISCOUNT:0,
        QTYONHAND:null,
        HTMLBOLTS: "",
        BOOKNSWATCH:[],
        RMCTAFBRANDVALUE:[],
        COLORWORKS:0,
        MINPRICE:null,
        MAXPRICE:null,
        RMCWORKROOMPRICECODE:"",
        RMCFIBCONT:"",
        ITEMATTRIBUTEDESC:"",
        RMCWIDTH:null,
        RMCWIDTHFINISHED:null,
        RMCVREPEAT:null,
        RMCHREPEAT:null,
        RMCRAILROADED:null,
        RMCMARTINRES:"",
        RMCWYZENRES:"",
        FIRE_RETARDANCY:[],
        COLOR_FASTNESS:"",
        SUNTAFGENDERVALUE:"",
        COUNTRYORIGIN:"",
        PA:"",
        SUNTAFITEMSTATUS: "",
        LONGDESCRIPTION:"",
        RMCEXCLUSIVE:"",
        AVAILABLECOLORS:[],
        PRODUCTIMAGES:[],
        PRODUCTTYPE:"",
        SRCSMALL:null,
        SRCLARGE:null,
        ABCCODEVALUEREF: "",
        ITEMGROUPID:"",
        DESIGN_NAME:"",
        TYPES:"",
      },
      orderstype: [
        { value: "regular", text: "Regular" },
        { value: "cutforapproval", text: "Cutting for approval" },
        { value: "holdtendays", text: "Hold for ten days" },
        { value: "memo", text: "Memo" }
      ],
      types: "",
      yard: ["yd"],
      size: "",
      clientscart: [
        { value: "1", text: "James" },
        { value: "2", text: "Mathew" },
        { value: "3", text: "John" },
        { value: "4", text: "Nick" }
      ],
      projects: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ],

      saveprojectcart: [
        { value: "1", text: "Lorem" },
        { value: "2", text: "Ipsum" },
        { value: "3", text: "Dolor" },
        { value: "4", text: "Lorem" }
      ],
      facebookshare:'https://www.facebook.com/sharer/sharer.php?u='+window.location.href,
      pintrestshare:'',
      houzzshare:'',
      isLoading: false,
      isLoadingBase: false,
      isDiscontinued: false,
      isHoldforTenAllowed: true,
      previousPrice:null,
      basestyleshow: false,
      baseFabrics: [],
      baseFabricsRegular: [],
      baseFabricsMemo: [],
      selectedBaseFabric: [],
      hasRecolors: [],
      breadcrumb: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "All Fabric",
          href: "#"
        },
        {
          text: "",
          active: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["user"]),
    basefabricname() {
      if (Object.keys(this.selectedBaseFabric).length > 0) {
        return this.selectedBaseFabric.NAME;
      }
      return '';
    }
  },
  methods: {
    hideModal() {
      this.$refs["modal"].hide();
      this.$refs["recolor_memo_notificaion_modal"].hide();
    },
    getBaseFabrics(){
      if(this.cartform.order_type.toLowerCase() == "regular"){
        this.baseFabrics = this.baseFabricsRegular;
      } else if(this.cartform.order_type.toLowerCase() == "memo"){
        this.baseFabrics = this.baseFabricsMemo;
      }
      if(this.cartform.order_type != ""){
        this.basestyleshow = true;
      }
    },
    closeBaseFabrics() {
      this.basestyleshow = false;
    },
    baseFabricSelected(fabric) {
      $(".requiredcut > .basestyle").removeClass("border-danger");
      $(".basestyle-error").addClass('d-none');
      this.selectedBaseFabric = fabric;
      this.basestyleshow = false;
      this.cartform.basestyle = fabric.INVENTSTYLEID;
      this.cartform.baseprice = fabric.AMOUNT;
      this.cartform.basefabricname = fabric.NAME;
      this.basefabricimage = fabric.URL;
    },
    computedPrice(multi = 1) {
      let price = '';
      if (Object.keys(this.selectedBaseFabric).length > 0) {
        price = parseFloat(this.selectedBaseFabric.AMOUNT * multi).toFixed(2);
      } else {
        price = `${parseFloat(this.info.MINPRICE * multi).toFixed(2).toString()} - $ ${parseFloat(this.info.MAXPRICE * multi).toFixed(2).toString()}`;
      }
      return price;
    },
    getPDF() {
      this.$store
        .dispatch("loadProductPDF", {
          itemid: this.$route.params.itemid,
          inventcolorid: this.$route.params.inventcolorid
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "product.pdf");
          document.body.appendChild(link);
          link.click();
        });
    },
    increment() {
      let currentqty = Number(this.cartform.quantity) + 1;
      this.cartform.quantity = Number(currentqty).toFixed(2);
      this.checkDiscontinedProductByQty(this.cartform.quantity);
      if (this.info.SUNTAFITEMSTATUS == 'DropShip' || (this.info.QTYONHAND >= currentqty)) {
        $(".noti_msg").addClass("HideNoti");
        if(this.isDiscontinued == true){
          $(".AddTOCartBtn").removeAttr("disabled");
        }
      } else {
        $(".noti_msg").removeClass("HideNoti");
        if(this.isDiscontinued == true){
          $(".AddTOCartBtn").attr("disabled",true);
        }
      }
    },
    handleInput(e){
      let stringValue = e.target.value.toString();
      let regex = /^\d*(\.\d{1,2})?$/
      if(!stringValue.match(regex) && this.cartform.quantity!== '') {
        this.cartform.quantity = this.previousPrice;
      }
      this.previousPrice = this.cartform.quantity;
      if (this.info.SUNTAFITEMSTATUS == 'DropShip' || (this.info.QTYONHAND >= this.cartform.quantity)) {
        $(".noti_msg").addClass("HideNoti");
        if(this.isDiscontinued == true){
          $(".AddTOCartBtn").removeAttr("disabled");
        }
      } else {
        $(".noti_msg").removeClass("HideNoti");
        if(this.isDiscontinued == true){
          $(".AddTOCartBtn").attr("disabled",true);
        }
      }
      this.checkDiscontinedProductByQty(this.cartform.quantity);
    },
    getProductBaseFabricsRegular(){
      this.isLoadingBase = true;
      this.$store.dispatch('getProductBaseFabrics', {
        itemId: this.$route.params.itemid,
        inventColorId: this.$route.params.inventcolorid,
      }).then(baseFabrics => {
        this.baseFabricsRegular = baseFabrics.data;
        this.baseFabrics = this.baseFabricsRegular;
        this.isLoadingBase = false;
      });
    },
    getProductBaseFabricsMemo(){
      this.isLoadingBase = true;
      this.$store.dispatch('getProductBaseFabrics', {
        itemId: this.$route.params.itemid+'-M',
        inventColorId: this.$route.params.inventcolorid,
      }).then(baseFabrics => {
        this.baseFabricsMemo = baseFabrics.data;
        this.baseFabrics = this.baseFabricsMemo;
        this.isLoadingBase = false;
      });
    },
    CheckCartOrderType() {
      this.selectedBaseFabric = [];
      $(".sigleproduct .ordertype.type .vs__dropdown-toggle").removeAttr("style");
      $(".ordertype.type .error-msg").remove();
      if (this.cartform.order_type.toLowerCase() == "memo") {
        $(".samediv.quantity, .ordertype.yard").css("display", "none");
        $(".noti_msg").addClass("HideNoti");
        $(".AddTOCartBtn").removeAttr("disabled");
        this.cartform.quantity = 1;
        if(this.info.COLORWORKS == '1'){
          this.getProductBaseFabricsMemo();
        }
      } else {
        $(".samediv.quantity, .ordertype.yard").css("display", "block");
        if (this.info.SUNTAFITEMSTATUS == 'DropShip' || (this.info.QTYONHAND >= this.cartform.quantity)) {
          $(".noti_msg").addClass("HideNoti");
          if(this.isDiscontinued == true){
            $(".AddTOCartBtn").removeAttr("disabled");
          }
        } else {
          $(".noti_msg").removeClass("HideNoti");
          if(this.isDiscontinued == true){
            $(".AddTOCartBtn").attr("disabled",true);
          }
        }
        if(this.info.COLORWORKS == '1'){
          this.getProductBaseFabricsRegular();
        }
        if(this.cartform.order_type.toLowerCase() == "holdtendays"){
          this.isHoldforTenAllowed = false;
        }else{
          this.isHoldforTenAllowed = true;
        }
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.cartform.itemid = this.productdetails[0].ITEMID;
      this.cartform.pc_type = this.productdetails[0].pc_Type;
      this.cartform.inventcolorid = this.productdetails[0].INVENTCOLORID;
      this.cartform.user_id = this.user.accountnumber;
      if (Object.keys(this.selectedBaseFabric).length == 0) {
        this.cartform.baseprice = this.info.PRICE;
      }
      this.cartform.discountedprice = this.info.DISCOUNTPRICE;
      var submit = 1;
      if(this.cartform.order_type ==""){
        submit = 0;
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").css("border-color","#f00");
        if($(".ordertype.type .error-msg").length == 0){
          $(".ordertype.type").append("<span class='error-msg'>Required Field</span>");
        }
        return false;
      }else{
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").removeAttr("style");
      }
      
      if(this.user.id > 0 && this.info.COLORWORKS == '1'){
        if (Object.keys(this.selectedBaseFabric).length > 0) {
          $(".requiredcut > .basestyle").removeClass("border-danger");
          $(".basestyle-error").addClass('d-none');
        } else{
          submit = 0;
          $(".requiredcut > .basestyle").addClass("border-danger");
          $(".basestyle-error").removeClass('d-none');
          return false;
        }
      }
      if (submit == 1) {
        this.isLoading = true;
        this.$store
          .dispatch("AddtoCart", {
            form: this.cartform
          })
          .then(rsdata => {
            if(rsdata.data.success == false){
              this.cartOrderMsg = rsdata.data.message;
              this.$refs["cartmodal"].show();
              this.isLoading = false;
            }else{
            this.$notify({
              text: "Product added to cart",
              type: "success"
            });
            this.selectedBaseFabric = [];
            this.isLoading = true;
            this.cartform.order_type = "";
            this.$store
              .dispatch("loadCart", this.user.accountnumber)
              .finally(() => {
                this.isLoading = false;
              });
            //reset form 
            }
          })
          .catch(error => {
            this.isLoading = false;
            if (this.cartform.hasErrors()) {
              this.$notify({
                text:
                  "There is a validation error. Please correct the fields outlined in red and try again.",
                type: "error"
              });
            } else {
              this.$notify({
                text: "Something went wrong!",
                type: "error"
              });
            }
          });
      }
    },
    editRecolor(){
      var submit = 1;
      if(this.cartform.order_type ==""){
        var submit = 1;
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").css("border-color","#f00");
        if($(".ordertype.type .error-msg").length == 0){
          $(".ordertype.type").append("<span class='error-msg'>Required Field</span>");
        }
        return false;
      }else{
        $(".ordertype.type .error-msg").remove();
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").removeAttr("style");
      }
      if(this.user.id > 0){
        if (Object.keys(this.selectedBaseFabric).length > 0) {
          $(".requiredcut > .basestyle").removeClass("border-danger");
          $(".basestyle-error").addClass('d-none');
        } else{
          submit = 0;
          $(".requiredcut > .basestyle").addClass("border-danger");
          $(".basestyle-error").removeClass('d-none');
          return false;
        }
      }
      if(Object.keys(this.selectedBaseFabric).length > 0 && this.cartform.order_type) {
        if(this.cartform.order_type.toLowerCase() == 'memo'){
          this.$refs["recolor_memo_notificaion_modal"].show();
        }else{
          window.location = `${this.hasRecolors.LINK}&basefabricname=${this.cartform.basefabricname}&order_type=${this.cartform.order_type}&inventstyleid=${this.cartform.basestyle}&quantity=${this.cartform.quantity}`;
        }
      }
    },
    redirectRecolor(){
      if(this.cartform.order_type.toLowerCase() == 'memo'){
        this.cartform.order_type = 'regular';
        this.baseFabrics = [];
        this.baseFabricsRegular = [];
        this.baseFabricsMemo = [];
        this.selectedBaseFabric = [];
        this.cartform.basestyle = "";
        this.cartform.basefabricname = "";
        this.cartform.baseprice = 0;
        this.CheckCartOrderType();  
        $(".requiredcut > .basestyle").addClass("border-danger");
        $(".basestyle-error").removeClass('d-none');
        this.$refs["recolor_memo_notificaion_modal"].hide();
      }
    },
    Submit1Popup(evt) {
      evt.preventDefault();

      this.form1.product_id = this.productdetails[0].ITEMID;
      this.form1.inventcolorid = this.productdetails[0].INVENTCOLORID;
      this.form1.inventstyleid = this.cartform.basestyle;
      this.form1.basefabricname = this.cartform.basefabricname;
      this.form1.pc_type = this.productdetails[0].pc_Type;
      this.form1.order_type = this.cartform.order_type;
      this.form1.notes = this.cartform.notes;
      this.form1.quantity = this.cartform.quantity;
      this.form1.recolor_id = this.cartform.recolor_id;

      this.isLoading = true;
      this.$store
        .dispatch("AddProductToProject", {
          form: this.form1
        })
        .then(response => {
          if (response.data.success) {
            this.form1.error_name = "";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
           /* this.form1 = new Form({
              client: null,
              project: null,
              error_name: ""
            });*/
            this.form1.client= null;
            this.form1.project= null;
            this.form1.error_name= "";

            this.hideModal();
            this.$refs["popupmodal"].hide();
            this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form1.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    Submit2Popup(evt) {
      evt.preventDefault();

      this.form2.product_id = this.productdetails[0].ITEMID;
      this.form2.inventcolorid = this.productdetails[0].INVENTCOLORID;
      this.form2.inventstyleid = this.cartform.basestyle;
      this.form2.basefabricname = this.cartform.basefabricname;
      this.form2.pc_type = this.productdetails[0].pc_Type;
      this.form2.order_type = this.cartform.order_type;
      this.form2.notes = this.cartform.notes;
      this.form2.quantity = this.cartform.quantity;
      this.form2.recolor_id = this.cartform.recolor_id;

      this.isLoading = true;
      this.$store
        .dispatch("AddProject", {
          form: this.form2
        })
        .then(response => {
          if (response.data.success) {
            this.form2.error_name = "";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });
           /* this.form2 = new Form({
              client_id: null,
              name: null,
              error_name: ""
            });*/
            this.form2.client_id= null;
            this.form2.name= null;

            this.hideModal();
            this.$refs["popupmodal"].hide();
            this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form2.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    Submit3Popup(evt) {
      evt.preventDefault();

      this.form.product_id = this.productdetails[0].ITEMID;
      this.form.inventcolorid = this.productdetails[0].INVENTCOLORID;
      this.form.inventstyleid = this.cartform.basestyle;
      this.form.basefabricname = this.cartform.basefabricname;
      this.form.pc_type = this.productdetails[0].pc_Type;
      this.form.order_type = this.cartform.order_type;
      this.form.notes = this.cartform.notes;
      this.form.quantity = this.cartform.quantity;
      this.form.user_id = this.user.accountnumber;
      this.form.recolor_id = this.cartform.recolor_id;

      this.isLoading = true;
      this.$store
        .dispatch("AddClientAndProject", {
          form: this.form
        })
        .then(response => {
          if (response.data.success) {
            //update clients dropdown
            this.LoadClients();
            this.form.error_name = "";
            this.$notify({
              text: "Product added successfully",
              type: "success"
            });

            this.form.createclient= null;
            this.form.createproject= null;
            this.form.error_name= "";

            this.hideModal();
            this.$refs["popupmodal"].hide();
            this.successtitle = "Product added successfully";
            this.$refs["successmodal"].show();
          } else {
            this.$notify({
              text: "please try again!",
              type: "error"
            });

            this.form.error_name = response.data.error;
          }
        });
      this.isLoading = false;
    },
    decrement() {
      if (this.cartform.quantity <= 1) {
        this.$notify({
          text: "0 Quantity not allowed",
          type: "error"
        });
      } else {
        let currentqty = Number(this.cartform.quantity) - 1;
        this.cartform.quantity = Number(currentqty).toFixed(2);
        this.checkDiscontinedProductByQty(this.cartform.quantity);
        if (this.info.SUNTAFITEMSTATUS == 'DropShip' || (this.info.QTYONHAND >= this.cartform.quantity)) {
          $(".noti_msg").addClass("HideNoti");
          if(this.isDiscontinued == true){
            $(".AddTOCartBtn").removeAttr("disabled");
          }
        } else {
          $(".noti_msg").removeClass("HideNoti");
          if(this.isDiscontinued == true){
            $(".AddTOCartBtn").attr("disabled",true);
          }
        }
      }
    },

    Showsavetoproject() {
      let saveToProject = false;

      if (this.cartform.order_type) {
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").removeAttr("style");
        saveToProject = true;
      } else if($(".ordertype.type .error-msg").length == 0){
        $(".sigleproduct .ordertype.type .vs__dropdown-toggle").css("border-color","#f00");
        $(".ordertype.type").append(
          "<span class='error-msg'>Required Field</span>"
        );
        saveToProject = false;
      }

      if(this.user.id > 0 && this.info.COLORWORKS == '1'){
        if (Object.keys(this.selectedBaseFabric).length > 0) {
          saveToProject = true;
          $(".requiredcut > .basestyle").removeClass("border-danger");
          $(".basestyle-error").addClass('d-none');
        } else{
          saveToProject = false;
          $(".requiredcut > .basestyle").addClass("border-danger");
          $(".basestyle-error").removeClass('d-none');
        }
      }

      if(saveToProject){
        this.resetModelForm();
        this.$refs["modal"].show();
      }
    },
    resetModelForm() {
      $(".ordertype.type .error-msg").remove();
      $(".savetoclient .error-msg").remove();
      this.showclient = false;
      this.shownewproject = false;
      this.shownewclient = false;
      //reset forms
      this.form.createclient = "";
      this.form.createproject = "";
      this.form.product_id = "";
      this.form.inventcolorid = "";
      this.form.pc_type = "";
      this.form.order_type = "";
      this.form.notes = "";
      this.form.quantity = "";
      this.form.user_id = "";
      this.form.cart = "";
      this.form.error_name = "";

      this.form1.client = "";
      this.form1.project = "";
      this.form1.product_id = "";
      this.form1.inventcolorid = "";
      this.form1.pc_type = "";
      this.form1.order_type = "";
      this.form1.notes = "";
      this.form1.quantity = "";
      this.form1.user_id = "";
      this.form1.cart = "";
      this.form1.error_name = "";

      this.form2.client_id = "";
      this.form2.name = "";
      this.form2.product_id = "";
      this.form2.inventcolorid = "";
      this.form2.pc_type = "";
      this.form2.order_type = "";
      this.form2.notes = "";
      this.form2.quantity;
      this.form2.user_id = "";
      this.form2.cart = "";
      this.form2.error_name = "";
    },
    getProjects() {
      if (this.form1.client) {
        $(".showProject").show();
        this.$store
          .dispatch("LoadClientProjects", this.form1.client)
          .then(loadprojects => {
            this.projects = loadprojects.data;
          });
      } else {
        $(".showProject").hide();
      }
    },
    showProject1() {
      if (this.form2.client_id) {
        $(".showProject1").show();
      } else {
        $(".showProject1").hide();
      }
    },
    showProject2() {
      if (this.form.createclient) {
        $(".showProject2").show();
      } else {
        $(".showProject2").hide();
      }
    },
    LoadClients() {
      if (this.user.id > 0) {
        this.$store
          .dispatch("LoadClient", this.user.accountnumber)
          .then(loadclients => {
            this.clientscart = loadclients.data;
          });
      }
    },
    hrefTarget(itemid, inventcolorid){
        return "_self";
    },
    statusTooltip(ABCCODEVALUE) {
      let str = "";
      if (ABCCODEVALUE == "M" || ABCCODEVALUE == "P") {
        str = "Discount and pricing applies to current stock only. Mill may have additional yardage, but must take entire minimum order quantity at regular price. If reordering from the mill, no discount applies and new pricing will be provided before the order is placed. A non-cancellable PO with 50% deposit will be required on new orders.";
      }
      if (ABCCODEVALUE == "XM" || ABCCODEVALUE == "XP") {
        str = "Item is discontinued by mill, discount applies to current stock only. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "X") {
        str = "Item is discontinued by mill, no discount is offered. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "Z") {
        str =
          "Closeout item, no new orders accepted. Discount applies to current stock only. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "XZ") {
        str =
          "Closeout item also discontinued by mill, discount applies to current stock only. RM COCO Decor Ltd. is no longer providing the service of locating discontinued goods. Please contact Customer Service for recommendations of potential replacements.";
      }
      if (ABCCODEVALUE == "L") {
        str = "Requires customer to purchase the full minimum order quantity if the item is still current with the mill.  If reordering from the mill, no discount applies and new pricing will be provided before the order is placed. A non-cancellable PO with 50% deposit will be required on new orders.";
      }
      return str;
    },
    changeimagesrc(productimg){
        this.info.SRCSMALL = productimg.LARGE_IMAGE;
        this.info.SRCLARGE = productimg.ORIGINAL_IMAGE;
    },
    loadswatchdata(detail,itemid,inventcolorid,event){
      $(".productbox .imgbox").removeClass("active");
      $(event.target).parents(".productbox").children(".imgbox").addClass("active");
      let buildurl = $(event.target).attr("href");
      let hoverimg = detail.MEDIUM_IMAGE;
      let colornamehvr = detail.COLORNAME;
      $(event.target).parents(".productbox").children(".imgbox").attr("href",buildurl);
      $(event.target).parents(".productbox").children(".imgbox").children(".proimg").attr("src",hoverimg);
      $(event.target).parents(".contentbox").children("h4").children("a").attr("href",buildurl);
      $(event.target).parents(".contentbox").children("h4").children("a").children(".clname").text(colornamehvr);
      let targetdata = this.hrefTarget(itemid,inventcolorid);
      $(event.target).parents(".productbox").children(".imgbox").attr("target",targetdata);
      $(event.target).parents(".contentbox").children("h4").children("a").attr("target",targetdata);
    },
    checkDiscontinedProductByQty(currentqty){
      if((this.info.ABCCODEVALUEREF == 'X' || this.info.ABCCODEVALUEREF == 'XM' || this.info.ABCCODEVALUEREF == 'XP' || this.info.ABCCODEVALUEREF == 'Y' || this.info.ABCCODEVALUEREF == 'Z') && this.info.QTYONHAND < currentqty){
        this.successtitle = "This item is discontinued with not enough stock to fill your request. Please reduce the quantity ordered or reselect.";
        this.$refs["successmodal"].show();
      }
    }
  }
};
</script>
<style>
  .showProject,
  .showProject1,
  .md-field.md-theme-default.showProject2 {
    display: none;
  }
  .singleproductdetails {
    width: 100%;
    position: relative;
    margin: 30px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .sigleproduct .headwrap.positionfix + .container {
    margin-top: 145px;
  }
  .mobile-title{
    display:none;
  }
  .sigleproduct span.saletag {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    display: inline-block;
    background: #303030;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    line-height: 34px;
    padding: 0 12px;
  }
  .sigleproduct span.saletag {
    background: red;
  }
  .sigleproduct .railroadtag{
    position: absolute;
    width: 100%;
    bottom: 0;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    background: #303030;
    color: #fff;
    font-weight: 600;
  }
  .sigleproduct p.regprice {
    text-decoration: line-through;
    margin-right: 8px;
    width: auto;
    float: left;
  }
  .sigleproduct .singlecontent .pricesection .samediv span.saleprice {
    color: red;
    font-size: 14px;
    font-weight: normal;
  }
  .singleimage {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: 50%;
    position: relative;
    max-width: 675px;
  }
  .singleimage .positionset {
    position: sticky;
    top: 120px;
  }
  .singleimage .highlight {
    height: 675px;
    width: 675px;
    border-radius: 3px;
    position: relative;
    margin-bottom: 30px;
  }
  .singleimage .highlight .vue-magnifier-container{
      overflow: hidden;
      display: inline-block;
      width: 100%;
  }
  .singleimage .highlight img.mainimage {
    width: 100%;
  }
  .singleimage .highlight a.downloadimg {
    position: absolute;
    background: #ececec;
    height:35px;
    width: 35px;
    top: 0;
    right: -45px;
    text-align: center;
    border-radius: 3px;
    opacity:1;
  }
  .singleimage .highlight a.downloadimg:hover{
    opacity: 0.8;
  }
  .singleimage .highlight a.downloadimg img.download {
    height: 15px;
    width: 15px;
    text-align: center;
    display: inline-block;
    margin-top: 10px;
  }
  .singleimage .smallimages {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: 80px;
  }
  .singleimage .smallimages .forborder {
    padding: 5px;
    border: 1px solid #fff;
    display: inline-block;
    width: auto;
    position: relative;
    margin-right: 25px;
    border-radius: 3px;
    text-decoration: none;
  }
  .singleimage .smallimages .forborder:hover,
  .singleimage .smallimages .forborder.selected {
    border: 1px solid #303030;
    text-decoration: none;
  }
  .singleimage .smallimages img.smallimg {
    height: 100px;
    width: 100px;
    border-radius: 3px;
  }
  .singleimage .vue-magnifier-container .preview {
    height: 675px;
    width: 675px;
  }
  .singlecontent {
    max-width: 660px;
    width: 50%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: baseline;
  }
  .singlecontent a.printdetails {
    font-size: 14px;
    float: right;
    color: #303030;
    text-decoration: none;
    font-weight: 600;
    position: absolute;
    right: 0;
    opacity: 1;
  }
  .singlecontent a.printdetails:hover{
    opacity: 0.8;
    text-decoration: underline;
  }
  .singlecontent h2 {
    font-size: 26px;
    line-height: 30px;
    text-align: left;
    float: left;
    width: 80%;
  }
  .singlecontent h3{
    margin-top: 10px;
    font-weight: 500;
    width: 100%;
    text-align: left;
  }
  .singlecontent a:hover {
    text-decoration: none !important;
  }
  .singlecontent a .print {
    height: 15px;
    width: 15px;
    margin-right: 5px;
    margin-top: -2px;
  }
  .singlecontent .pricesection {
    position: relative;
    overflow: hidden;
    width: 100%;
    display: inline-block;
    margin-top: 10px;
  }
  .singlecontent .pricesection .samediv {
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
  }
  .singlecontent .pricesection .samediv span {
    float: left;
    color: #303030;
    margin-right: 5px;
    font-size: 14px;
  }
  .singlecontent .pricesection .samediv p {
    font-weight: 500;
    color: #303030;
    font-size: 14px;
  }
  .singlecontent .specification {
    width: 100%;
    position: relative;
    margin: 15px 0 0 0;
  }
  .singlecontent .specification:last-child {
    border-bottom: 0;
  }
  .singlecontent .specification h3 {
    text-align: left;
    margin-bottom: 20px;
  }
  .singlecontent .specification .spec_details,
  .accordion .specification .spec_details {
    width: 100%;
    position: relative;
    display: inline-block;
    margin-bottom: 0;
  }
  .singlecontent .specification .spec_details .lblspec,
  .accordion .specification .spec_details .lblspec{
    color: #303030;
    font-size: 14px;
    float: left;
    line-height: 24px;
  }
  .singlecontent .specification .spec_details .lblspec {
    width: 230px;
  }
  .accordion .specification .spec_details .lblspec {
    width: 130px;
  }
  .singlecontent .specification .spec_details .txtspec,
  .accordion .specification .spec_details .txtspec{
    color: #303030;
    font-size: 14px;
    float: left;
    line-height: 24px;
  }
  .singlecontent .specification .spec_details .txtspec {
    width: calc(100% - 230px);
  }
  .accordion .specification .spec_details .txtspec {
    width: calc(100% - 130px);
  }
  .singlecontent .specification .spec_details p .infoimg {
    width: 15px;
    height: 15px;
    float: right;
    margin: 3px 0 0 12px;
    cursor: pointer;
  }
  .singlecontent .specification .spec_details.firediv div.firelist .firename,
  .singlecontent .specification .spec_details.firediv div.firelist .firecomma {
    float: left;
  }
  .singlecontent .specification .spec_details_flex{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }
  .singlecontent .specification .spec_details_flex .infoimg{
    width: 15px;
    height: 15px;
    margin: 10px 0 20px 0px;
    cursor: pointer;
  }
  .singlecontent .detailed-options .avail_colors.smallimages {
    width: 100%;
    display: flex;
    justify-content: left;
    position: relative;
    flex-wrap: wrap;
    margin-bottom: 5px;
    margin-top: 15px;
  }
  .singlecontent .detailed-options .avail_colors.smallimages .forborder {
    padding: 3px;
    border: 1px solid #fff;
    display: inline-block;
    width: auto;
    position: relative;
    margin-right: 5px;
    margin-bottom: 5px;
    border-radius: 3px;
    text-decoration: none;
  }
  .singlecontent .detailed-options .avail_colors.smallimages .forborder.selected {
    border: 1px solid #303030;
    text-decoration: none;
  }
  .singlecontent .detailed-options .avail_colors.smallimages .colorimg {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 3px;
  }
  .singlecontent .detailed-options .avail_colors.smallimages .colortag{
    display: block;
    font-size: 10px;
    line-height: 13px;
    margin-top: 5px;
    max-width:60px;
  }
  .singlecontent .shareus {
    width: 100%;
    position: relative;
    display: inline-block;
    margin-bottom: 20px;
    margin-top:20px;
  }
  .singlecontent .shareus p {
    font-size: 14px;
    font-weight: 500;
    color: #303030;
    float: left;
    margin: 2px 15px 0 0px;
  }
  .singlecontent .shareus ul {
    float: left;
  }
  .singlecontent .shareus ul li {
    float: left;
    margin-right: 15px;
  }
  .singlecontent .shareus ul li a img.social_icon {
    max-width: 23px;
    width: 23px;
  }
  .singlecontent .needhelp {
    padding: 35px;
    box-sizing: border-box;
    background: #ececec;
    position: relative;
    display: inline-block;
    width: 100%;
    margin-bottom: 80px;
  }
  .singlecontent .needhelp .callwrite {
    display: flex;
    justify-content: space-between;
  }
  .singlecontent .needhelp .callus h4,
  .singlecontent .needhelp .writeus h4 {
    text-align: left;
    margin-bottom: 8px;
  }
  .singlecontent .needhelp a {
    font-size: 14px;
    line-height: 20px;
    margin-top: 12px;
    text-decoration: none;
    color: #303030;
    font-weight: normal;
    text-align: left;
    width: 100%;
  }
  .singlecontent .needhelp a img {
    height: 14px;
    width: 14px;
    display: inline-block;
    margin: 0 10px 0 0;
  }
  .singlecontent .needhelp span {
    font-size: 12px;
    color: #777777;
    margin-top: 8px;
    display: inline-block;
    font-weight: normal;
  }
  .sigleproduct .diff_li{
    padding:20px 0 0 0;
  }
  .sigleproduct .fixedbar {
    /*position: sticky;
    bottom: 0;
    left: 0;
    height: 100px;*/
    background: #ececec;
    width: 100%;
    /*z-index: 111;*/
    margin-top: 0;
  }
  .sigleproduct .fixedbar .beforesignin {
    position: relative;
    width: 100%;
    padding: 25px;
    box-sizing:border-box;
    margin-bottom:4px;
  }
  .sigleproduct .fixedbar .beforesignin h3 {
    margin: 0 25px 0 0;
  }
  .sigleproduct .fixedbar .beforesignin .buttonsdiv{
    display:flex;
    margin-top:35px;
  }
  .sigleproduct .fixedbar .beforesignin .btn {
    min-width: 140px;
    margin-right: 25px;
  }
  .sigleproduct .fixedbar .beforesignin .btn:last-child{
    margin-right:0;
  }
  .sigleproduct .fixedbar .noti_msg {
    font-size: 10px;
    font-weight: normal;
    color: #ff0101;
    margin: 0 0 20px 0;
    display: inline-block;
    width: 100%;
    text-align: center;
  }
  .sigleproduct .fixedbar .noti_msg_btm{
    margin: 20px 0 0 0;
    color: #303030;
    text-align: left;
    font-size: 10px;
    font-weight: normal;
    width: 100%;
  }
  .sigleproduct .fixedbar .noti_msg_btm a {
    font-size: 10px;
    width: auto;
    color: #1e90ff;
  }
  .sigleproduct .fixedbar .noti_msg.HideNoti {
    display: none;
  }
  .sigleproduct .fixedbar .afterlogin {
    display: flex;
    align-items: center;
    justify-content: left;
    width: 100%;
    flex-wrap: wrap;
    padding: 25px;
    box-sizing:border-box;
    margin-bottom:5px;
  }
  .sigleproduct .ordertype {
    width: 55.8%;
    margin-right: 25px;
  }
  .sigleproduct .ordertype .vs--unsearchable .vs__dropdown-toggle{
    top:0;
  }
  .sigleproduct .ui.selection.dropdown,
  .common_pop .ui.selection.dropdown {
    float: left;
    -webkit-transition: inherit;
    transition: inherit;
    box-shadow: none;
    border: 1px solid #d2d2d2;
    border-radius: 3px;
    padding: 11.5px 25px 11.5px 15px;
  }
  .common_pop .ui.selection.dropdown {
    margin-bottom: 15px;
    margin-top: 20px;
  }
  .common_pop.saveto_project .btn-dark {
    margin-top: 15px;
  }
  .sigleproduct .ui.search.dropdown > .text,
  .common_pop .ui.search.dropdown > .text {
    color: #303030 !important;
    font-size: 12px;
  }
  .sigleproduct .ui.search.dropdown > input.search,
  .common_pop .ui.search.dropdown > input.search {
    font-weight: 600;
    color: #303030 !important;
  }
  .sigleproduct .ui.selection.dropdown .menu > .item.selected,
  .common_pop .ui.selection.dropdown .menu > .item.selected {
    font-weight: 600;
  }
  .sigleproduct .ui.search.selection.dropdown > input.search,
  .common_pop .ui.search.selection.dropdown > input.search {
    padding-right: 15px;
    padding-left: 15px;
  }
  .sigleproduct .ui.search.dropdown > .text,
  .common_pop .ui.search.dropdown > .text {
    color: #303030;
    font-weight: 600;
  }
  .sigleproduct .ui.selection.dropdown::after,
  .common_pop .ui.selection.dropdown::after {
    content: "";
    background: url(/shop/images/arrow.svg) no-repeat center;
    height: 10px;
    width: 10px;
    position: absolute;
    right: 12px;
    top: 15px;
    margin: 0;
  }
  .sigleproduct .ui.selection.dropdown.active::after,
  .common_pop .ui.selection.dropdown.active::after {
    transform: rotate(180deg);
  }
  .sigleproduct .ui.selection.dropdown:hover,
  .common_pop .ui.selection.dropdown:hover {
    border: 1px solid #d2d2d2;
    border-radius: 3px;
  }
  .sigleproduct .ui.fluid.dropdown > .dropdown.icon,
  .common_pop .ui.fluid.dropdown > .dropdown.icon {
    display: none;
  }
  .sigleproduct .ui.search.dropdown > input.search,
  .sigleproduct .ui.search.dropdown > .text,
  .common_pop .ui.search.dropdown > input.search,
  .common_pop .ui.search.dropdown > .text {
    color: #303030 !important;
    font-size: 12px;
    font-weight: normal;
  }
  .sigleproduct .ui.selection.active.dropdown:hover,
  .sigleproduct .ui.selection.active.dropdown:hover .menu,
  .common_pop .ui.selection.active.dropdown:hover,
  .common_pop .ui.selection.active.dropdown:hover .menu {
    border-color: #d2d2d2;
    box-shadow: none;
  }
  .sigleproduct .ui.search.selection.dropdown > input.search,
  .sigleproduct .ui.search.selection.dropdown > span.sizer,
  .common_pop .ui.search.selection.dropdown > input.search,
  .common_pop .ui.search.selection.dropdown > span.sizer {
    line-height: 1.8em;
  }
  .sigleproduct .ui.selection.dropdown .menu,
  .common_pop .ui.selection.dropdown .menu {
    top: -155px;
    border-radius: 0 !important;
    border: 1px solid #d2d2d2;
    border-top: 1px solid #d2d2d2 !important;
    padding: 10px 0;
  }
  .common_pop .ui.selection.dropdown .menu {
    top: 40px;
  }
  .sigleproduct .ui.selection.dropdown .menu > .item,
  .common_pop .ui.selection.dropdown .menu > .item {
    font-size: 12px;
    line-height: 20px;
    color: #303030;
    padding: 0;
    border: 0;
  }
  .sigleproduct .ui.selection.dropdown .menu,
  .sigleproduct .ui.selection.dropdown .menu > .item,
  .common_pop .ui.selection.dropdown .menu,
  .common_pop .ui.selection.dropdown .menu > .item {
    font-size: 12px;
    line-height: 16px;
    color: #303030;
  }
  .sigleproduct .ui.fluid.dropdown > .dropdown.icon,
  .common_pop .ui.fluid.dropdown > .dropdown.icon {
    display: none;
  }
  .sigleproduct .ui.selection.dropdown .menu > .item:hover,
  .sigleproduct .ui.selection.dropdown .menu > .item.selected,
  .common_pop .ui.selection.dropdown .menu > .item:hover,
  .common_pop .ui.selection.dropdown .menu > .item.selected {
    background: transparent;
  }
  /*===*/
  .sigleproduct .v-select {
    position: relative;
    width: 100%;
    float: left;
  }
  .sigleproduct .vs__dropdown-toggle {
    height: 38px;
    padding: 0;
    border: 1px solid #d2d2d2;
    border-radius: 3px;
    background: #fff;
  }
  .sigleproduct .vs__dropdown-menu {
    /* top: -155px; */
    top: 40px !important;
    border: 1px solid #d2d2d2;
    box-shadow: none;
    width: 100%;
    font-weight: normal;
  }
  .sigleproduct .fixedbar .afterlogin .ordertype.yard .vs__dropdown-menu {
    top: -47px;
    min-width: 66px;
  }
  .sigleproduct .v-select .vs__actions::after {
    border: none;
    content: "";
    background: url(/shop/images/arrow.svg) no-repeat center;
    height: 10px;
    width: 10px;
    position: absolute;
    right: 12px;
    top: 14px;
    margin: 0;
  }
  .sigleproduct .vs__actions .vs__open-indicator {
    display: none;
  }
  .sigleproduct .v-select.vs--open .vs__actions::after {
    transform: rotate(180deg);
  }
  .sigleproduct .vs--single .vs__selected {
    font-size: 12px;
    color: #303030;
    padding: 0 7px 0 13px;
  }
  .sigleproduct .fixedbar .afterlogin .ordertype.yard .vs--single .vs__selected {
    line-height: 30px;
  }
  .sigleproduct .vs--single.vs--open .vs__selected {
    position: relative;
    opacity: 1;
  }
  .sigleproduct .vs__dropdown-option {
    font-size: 12px;
    color: #303030;
    line-height: 30px;
    font-weight: normal;
  }
  .sigleproduct .vs__dropdown-option:hover {
    font-weight: 600;
  }
  .sigleproduct .vs__dropdown-option--highlight {
    background: transparent;
    color: #303030;
  }
  .sigleproduct .vs__search,
  .sigleproduct .vs__search:focus {
    padding: 0 7px 0 13px;
    font-size: 12px;
    font-weight: normal;
    color: #303030;
  }
  /*===*/
  .common_pop .ui.search.dropdown > .text.default {
    position: relative;
    top: -20px;
    background: #fff;
    padding: 0 3px;
  }
  .sigleproduct .fixedbar .samediv.quantity {
    margin-right: 12px;
    width: 23.1%;
  }
  .sigleproduct .fixedbar .samediv.quantity span {
    margin-top: 5px;
  }
  .sigleproduct .fixedbar .samediv .qtydiv span {
    float: left;
    font-size: 18px;
    border: 1px solid #d2d2d2;
    margin: 0;
    height: 43px;
    line-height: 43px;
    padding: 0 14px;
    font-weight: 500;
    color: #303030;
    -webkit-border-top-left-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    -moz-border-radius-bottomleft: 3px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    cursor: pointer;
    background: #fff;
  }
  .sigleproduct .fixedbar .samediv .qtydiv span.lastspan {
    -webkit-border-top-right-radius: 3px;
    -webkit-border-bottom-right-radius: 3px;
    -moz-border-radius-topright: 3px;
    -moz-border-radius-bottomright: 3px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    -webkit-border-top-left-radius: 0;
    -webkit-border-bottom-left-radius: 0;
    -moz-border-radius-topleft: 0;
    -moz-border-radius-bottomleft: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    line-height: 44px;
  }
  .sigleproduct .fixedbar .samediv .qtydiv input {
    float: left;
    max-width: 55px;
    font-size: 14px;
    height: 43px;
    text-align: center;
    border-top: 1px solid #d2d2d2;
    border-bottom: 1px solid #d2d2d2;
    border-left: 0;
    border-right: 0;
    font-weight: 500;
    color: #303030;
    padding-top: 6px;
  }
  .sigleproduct .fixedbar .ordertype.yard {
    width: 14.9%;
    margin-right:0;
  }
  .sigleproduct
    .fixedbar
    .afterlogin
    .ordertype.yard
    .ui.selection.dropdown
    .menu {
    top: -60px;
  }
  .sigleproduct .fixedbar .requiredcut {
    width: 55.8% !important;
    margin:20px 0 0 0;
    position: relative;
    margin-right: 25px;  
  }
  .singlecontent .fixedbar .cartformnotes.bsstyle {
    margin-top: 20px;
  }
  .singlecontent .fixedbar .requiredcut.basefabricimg {
    width: 103px !important;
  }
  .sigleproduct .fixedbar .requiredcut input {
    width: 100%;
    height: 40px;
    font-size: 12px;
    color: #777777;
    padding: 5px 20px;
    box-sizing: border-box;
    border-radius: 3px;
    border: 1px solid #d2d2d2;
    font-weight: normal;
  }
  .sigleproduct .fixedbar .requiredcut.bsbox .basestyle{
    cursor: pointer;
  }
  .sigleproduct .fixedbar .requiredcut.bsbox svg, 
  .sigleproduct .fixedbar .requiredcut.bsbox img.edit-alt {
    position: absolute;
    right: 20px;
    top: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .sigleproduct .fixedbar .afterlogin .barbuttons{
    margin-top: 20px;
  }
  .sigleproduct .fixedbar .barbuttons button.btn.btn-dark {
    width: 350px;
    margin-right: 30px;
    margin-top: 0;
  }
  .sigleproduct .fixedbar .barbuttons button.btn.btn-outline-primary {
    width: 225px;
    margin-top: 0;
  }
  .sigleproduct .fixedbar .barbuttons .saveproject {
    height: 15px;
    width: 11px;
    margin: -3px 8px 0 0;
  }
  .sigleproduct .fixedbar .barbuttons .saveproject.white {
    display: none;
  }
  .sigleproduct
    .fixedbar
    .barbuttons
    button.btn.btn-outline-primary:hover
    .saveproject {
    display: none;
  }
  .sigleproduct
    .fixedbar
    .barbuttons
    button.btn.btn-outline-primary:hover
    .saveproject.white {
    display: inline-block;
    margin-right:12px;
  }
  .similarcontent {
    width: 100%;
    position: relative;
    display: inline-block;
    border-top: 1px solid #d2d2d2;
    padding-top: 75px;
  }
  .similarcontent h1 {
    margin-bottom: 40px;
  }
  .basestylecontainer{
    width: 40%;
    background: #fff;
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 20;
    padding: 25px 35px;
  }
  .ps {
    height: calc(100vh - 100px);
    width:100%;
  }
  .sigleproduct .similarcontent .commonslider {
    width: 100%;
    position: relative;
  }
  .sigleproduct .similarcontent .commonslider .slideimg {
    height: 265px;
    width: 265px;
    position: relative;
    border-radius: 3px;
    overflow: hidden;
  }
  .sigleproduct .similarcontent .commonslider .slideimg img {
    width: 100%;
  }
  .sigleproduct .similarcontent .commonslider .slideimg .newtag,
  .sigleproduct .similarcontent .commonslider .slideimg .saletag {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    display: inline-block;
    background: #303030;
    color: #fff;
    font-weight: 600;
    font-size: 12px;
    line-height: 25px;
    padding: 0 8px;
  }
  .sigleproduct .similarcontent .commonslider .slideimg .saletag {
    background: red;
  }
  .sigleproduct .similarcontent .commonslider h4 {
    text-align: left;
    margin-bottom: 3px;
  }
  .sigleproduct .similarcontent .commonslider h4 a {
    color: #303030;
    text-decoration: none;
    font-size: 14px;
    display: inline-block;
    width: 100%;
    margin-top: 8px;
  }
  .sigleproduct .similarcontent .commonslider p {
    font-size: 12px;
    line-height: 24px;
    color: #303030;
    text-align: left;
    width: 100%;
    font-weight: normal;
    float: left;
  }
  .custom-arrow.slick-arrow.slick-prev,
  .custom-arrow.slick-arrow.slick-next {
    height: 40px;
    width: 40px;
    background: #ececec;
    left: -65px;
    top: 45%;
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -45%);
    border-radius: 3px;
    border: 1px solid #ececec;
  }
  .custom-arrow.slick-arrow.slick-prev:hover,.custom-arrow.slick-arrow.slick-next:hover{
    background: transparent;
  }
  .custom-arrow.slick-arrow.slick-next {
    right: -58px;
    left: inherit;
  }
  .custom-arrow.slick-arrow.slick-prev::before,
  .custom-arrow.slick-arrow.slick-next::before {
    content: "";
    background: url(/shop/images/arrow.svg) no-repeat center;
    height: 12px;
    width: 12px;
    margin: 0;
    background-size: cover;
    opacity: 1;
    position: absolute;
    transform: rotate(90deg);
    top: 14px;
    left: 12px;
  }
  .custom-arrow.slick-arrow.slick-next::before {
    transform: rotate(-90deg);
  }
  .recentlyview .custom-arrow.slick-arrow.slick-prev,
  .recentlyview .custom-arrow.slick-arrow.slick-next,
  .similarcontent.similarfabric .custom-arrow.slick-arrow.slick-prev,
  .similarcontent.similarfabric .custom-arrow.slick-arrow.slick-next{
    top: 35%;
  }
  .similarcontent.similarfabric,
  .similarcontent.recentlyview {
    /*border-top: 0;*/
    padding-top: 70px;
  }
  .similarcontent.similarfabric .mainproducts{
    margin-bottom:30px;
  }
  .similarcontent.recentlyview {
    border-top:0;
    padding-top:0;
  }
  .common_pop.saveto_project .modal-dialog.modal-md .modal-content {
    padding: 20px 25px 40px 25px;
  }
  .common_pop.saveto_project .modal-header h3.modal-title {
    display: none;
  }
  .saveto_project .projectoptions {
    width: 100%;
    position: relative;
    animation: animateleft 0.3s;
  }
  .saveto_project .projectoptions ul li {
    line-height: 65px;
    border-bottom: 1px solid #d2d2d2;
    position: relative;
  }
  .saveto_project .projectoptions ul li:last-child {
    border-bottom: 0;
  }
  .saveto_project .projectoptions ul li::after {
    content: "";
    background: url(/shop/images/arrow.svg) no-repeat center;
    height: 12px;
    width: 12px;
    position: absolute;
    top: 28px;
    right: 0;
    transform: rotate(-90deg);
  }
  .saveto_project .projectoptions ul li a {
    color: #303030;
    font-size: 14px;
    text-align: none;
    font-weight: 500;
  }
  .saveto_project .projectoptions ul li a:hover {
    text-decoration: none;
  }
  .saveto_project .savetoclient {
    position: relative;
    animation: animateright 0.3s;
    box-sizing: border-box;
    display: inline-block;
    width: 100%;
    padding: 0 15px 0 15px;
  }
  .saveto_project .savetoclient a {
    font-size: 14px;
    color: #303030;
    text-decoration: none;
    font-weight: 600;
    position: absolute;
    top: -30px;
    left: -10px;
  }
  .saveto_project .savetoclient a:hover {
    text-decoration: none;
  }
  .saveto_project .savetoclient .slidearrow {
    height: 12px;
    width: 12px;
    transform: rotate(90deg);
    margin: -2px 5px 0 0;
  }
  .saveto_project .savetoclient h3 {
    margin-bottom: 20px;
  }
  .saveto_project .savetoclient.newcreation h3 {
    margin-bottom: 15px;
  }
  .saveto_project .savetoclient.newcreation .commonform .md-field {
    margin-bottom: 15px;
  }
  .saveto_project .savetoclient.newcreation .btn.btn-dark {
    margin-top: 25px;
  }
  .singlecontent .detailed-options{
    position:relative;
    margin:10px 0 0 0;
    padding:0;
    width:100%;
  }
  .detailed-options ul.new_ul > li{
    border-top: 1px solid #d2d2d2;
      padding: 13.5px 0;
    width:100%;
  }
  .detailed-options ul.new_ul > li:last-child{
    border-bottom: 1px solid #d2d2d2;
  }
  .detailed-options ul li a{
    font-weight:500;
    font-size:16px;
    color:#303030;
    width:100%;
    display:inline-block;
  }
  .detailed-options ul.new_ul > li:hover > a{
    font-weight: 700;
  }
  .detailed-options ul li a img.addicon{
      height: 11px;
      width: 11px;
      float: right;
      margin-top: 5px;
  }
  .detailed-options ul li a.not-collapsed img.addicon{
    transform:rotate(180deg);
  }
  .detailed-options ul li a.cwsampledeck{
    display: block;
    margin-top: 20px;
  }
  /* .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
  .slide-fade-leave-active below version 2.1.8 {
    transform: translateX(10px);
    opacity: 0;
  } */
  span.blue-msg{
    color: #1e90ff;
    margin-top: 5px;
    display: inline-block;
    font-size: 12px;
  }
  .trim_t_info{
    width: 40%;
    margin: 20px 0 0 0;
    text-align: left;
    display: inline-block;
    color: #f00;
    font-size: 12px;
  }
  @keyframes animateright {
    from {
      right: -400px;
      opacity: 0;
      visibility: hidden;
    }
    to {
      right: 0;
      opacity: 1;
      visibility: visible;
    }
  }
  @keyframes animateleft {
    from {
      left: -400px;
      opacity: 0;
      visibility: hidden;
    }
    to {
      left: 0;
      opacity: 1;
      visibility: visible;
    }
  }
  @media only screen and (max-width: 1540px) and (min-width: 1441px) {
    .custom-arrow.slick-arrow.slick-prev {
      z-index: 1;
      left: 0;
    }
    .custom-arrow.slick-arrow.slick-next {
      right: 15px;
      z-index: 1;
    }
  }
  @media only screen and (max-width: 1440px) {
    .singleimage .highlight {
      height: 580px;
      width: 580px;
    }
    .singlecontent {
      max-width: 560px;
    }
    .singlecontent .needhelp {
      padding: 35px 20px;
    }
    .sigleproduct .similarcontent .commonslider .slideimg,
    .mainproducts .productbox .imgbox {
      height: 225px;
      width: 225px;
    }
    .mainproducts .productbox .contentbox {
      max-width: 225px;
    }
    .singleimage .vue-magnifier-container .preview {
      height: 580px;
      width: 580px;
    }
    .singleimage .highlight a.downloadimg{
    right:-47px;
    }
    .sigleproduct .ordertype{
    width: 48.8%;
    }
    .sigleproduct .fixedbar .samediv.quantity{
      width: 28.5%;
    }
    .sigleproduct .fixedbar .barbuttons button.btn.btn-dark{
      width:250px;
    }
    .sigleproduct .fixedbar .requiredcut {
      width: 48.8% !important;
    }
    .basestylecontainer{
      width: 70%;
    }
  }
  @media only screen and (max-width: 1330px) {
    .custom-arrow.slick-arrow.slick-prev {
      z-index: 1;
      left: 0;
    }
    .custom-arrow.slick-arrow.slick-next {
      right: 15px;
      z-index: 1;
    }
  }
  @media only screen and (max-width: 1199px) and (min-width: 1025px) {
    .singleimage .highlight {
        height: 410px;
        width: 410px;
    }
    .singleimage .vue-magnifier-container .preview {
      height: 410px;
      width: 410px;
    }
    .singleimage .smallimages img.smallimg{
      height: 70px;
      width: 70px;
    }
    .singleimage .smallimages .forborder{
      margin-right:10px;
    }
    .sigleproduct .fixedbar .afterlogin{
      padding: 25px 0;
    }
    .sigleproduct .ordertype {
        width: 45.8%;
        margin-right: 20px;
    }
    .sigleproduct .fixedbar .samediv.quantity {
        width: 31.5%;
    }
    .singlecontent h2{
      font-size: 22px;
    }
    .afterlogin .vs--unsearchable .vs__dropdown-toggle {
        height: 41px;
        top: 0;
    }
    .sigleproduct .fixedbar .barbuttons button.btn.btn-dark {
      width: 210px;
    }
    .sigleproduct .fixedbar .barbuttons button.btn.btn-outline-primary{
      width: 200px;
    }
    .sigleproduct .similarcontent .commonslider .slideimg, .mainproducts .productbox .imgbox {
        height: 195px;
        width: 195px;
    }
    .sigleproduct .fixedbar .requiredcut {
      width: 45.8% !important;
      margin-right: 20px;
    }
  }
  @media only screen and (max-width:1024px) and (min-width:768px){
    .headwrap.positionfix + .accountdetails .sidebar, .headwrap.positionfix + .accountdetails.mainprojectsection .orderspage.projectspage .projectlistbar {
      top: 70px;
      }
    .singleimage{
      max-width: 730px;
      margin: 0 auto;  
      width: 100%;  
    }
    .singlecontent {
      max-width: 730px;
      margin: 0 auto; 
      width:100%;
    } 
    .singlecontent h2,.singlecontent a.printdetails{
      display: none;
    }
    .singleimage .smallimages{
      margin-bottom: 40px;
    }
    .mobile-title{
      width: 100%;
      max-width: 730px;
      margin: 0 auto 20px auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .mobile-title a{
      color: #303030;
      text-decoration: none;
      font-weight: 600;
      font-size:14px;
    }
    .mobile-title h2{
      line-height:30px;
      margin-bottom:12px;
      text-align: left;
    }
    .mobile-title a{
      margin-bottom:0;
      display:inline-block;
    }
    .mobile-title a .print {
      height: 15px;
      width: 15px;
      margin-right: 5px;
      margin-top: -2px;
    }
    .sigleproduct .fixedbar .afterlogin{
      padding: 25px 0;
    }
    .sigleproduct .fixedbar .ordertype.yard,.sigleproduct .ordertype{
      margin-top: -6px;
    }
    .sigleproduct .similarcontent .commonslider .slideimg, .mainproducts .productbox .imgbox{
      height: 195px;
      width: 195px;
      max-width: 195px;
    }
  }
  @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2){
    .mobile-title{
      display:none;
    }
    .singleimage,.singlecontent{
      max-width:inherit;
      width:54%;
    }
    .singleimage{
      width:46%;
      margin:0;
    }
    .singleimage .highlight a.downloadimg {
      right: -40px;
    }
    .singlecontent h2, .singlecontent a.printdetails{
      display:block;
    }
    .singleimage .highlight,.singleimage .vue-magnifier-container .preview{
      height: 400px;
      width: 400px;
    }
    .singleimage .smallimages .forborder{
      margin-right:10px;
    }
    .singleimage .highlight{
      margin-bottom:15px;
    }
    .singleimage .smallimages img.smallimg{
      height:70px;
      width:70px;
    }
    .vue-magnifier-container .preview .magnifying-glass{
      display:none !important;
    }
    .sigleproduct .fixedbar .barbuttons button.btn.btn-dark {
      width: 230px;
    }
  }
  @media only screen and (max-width:767px){
    .sigleproduct .fixedbar .beforesignin{
      padding:25px 0;
    }
    .singleimage{ 
      width:100%;
      max-width:100%;
    }
    .singleimage .positionset{
      position:relative;
      top:auto;
    }
    .singlecontent,.singleimage .highlight,.singleimage .vue-magnifier-container .preview{
        max-width: 100%;
        width: 100%;
    }
    .singleimage .vue-magnifier-container .preview{
      background-size:cover;
    }
    .singleimage .highlight, .singleimage .vue-magnifier-container .preview{
      height:350px;
    }
    .singleimage .highlight{
      margin-bottom:10px;
    }
    .singleimage .highlight a.downloadimg {
        right: 20px;
        top: 10px;
    }
    .singleimage .smallimages .forborder{
      margin-right:0;
    }
    .singleimage .smallimages img.smallimg{
      height: 60px;
        width: 60px;
    }
    .singlecontent .needhelp{
      padding: 35px 15px 45px 15px;
    margin-bottom:60px;
    }
    .singlecontent .needhelp .callwrite {
        flex-wrap: wrap;
    }
    .singlecontent .needhelp .callwrite .callus {
        margin-bottom: 20px;
    }
    .singleimage .smallimages{
      margin-bottom:20px;
    }
    .singlecontent h2{
      font-size:22px;
      width:71%;
      display:none;
    }
    .singlecontent a.printdetails{
    display:none;
    }
    .singlecontent .pricesection .samediv span,.singlecontent .pricesection .samediv p,.singlecontent a.printdetails{
      font-size:14px;
    }	
    .sigleproduct .fixedbar .afterlogin{
      padding-left:0;
      padding-right:0;
    }
    .sigleproduct .ordertype {
      width: 100%;
      margin-right: 0;
      margin-bottom:22px;
    }
    .sigleproduct .fixedbar .samediv.quantity{
      width:45%;
    }
    .vue-magnifier-container .preview .magnifying-glass{
      display:none !important;
    }
    .sigleproduct .fixedbar .ordertype.yard{
      width:23%;
      margin-bottom: 0;
      margin-top: 0;
    }
    .sigleproduct .fixedbar .afterlogin .barbuttons{
      text-align:center;
      width:100%;
    }
    .sigleproduct .fixedbar .barbuttons button.btn.btn-dark {
      width: 100%;
      margin: 0 0 20px 0;
    }
    .sigleproduct .fixedbar .barbuttons button.btn.btn-outline-primary {
      width: 100%;
      margin-top: 0;
    }
    .mainproducts .productbox{
      margin-right:0;
    }
    .sigleproduct .similarcontent .commonslider .slideimg, .mainproducts .productbox .imgbox{
      height:265px;
      width:100%;
    }
    .mainproducts .productbox .imgbox img.proimg{
      height:265px;
      object-fit:cover;
    }
    .mobile-title{
      display:block;
    }
    .mobile-title a{
      color: #303030;
      text-decoration: none;
      font-weight: 600;
      font-size:14px;
    }
    .mobile-title h2{
      line-height:30px;
      margin-bottom:12px;
    }
    .mobile-title a{
      margin-bottom:20px;
      display:inline-block;
    }
    .mobile-title a .print {
      height: 15px;
      width: 15px;
      margin-right: 5px;
      margin-top: -2px;
    }
    .singlecontent .specification .spec_details span, .singlecontent .specification .spec_details p, .singlecontent .specification .spec_details.firediv div.firelist{
      font-size: 12px;
    }
    .custom-arrow.slick-arrow.slick-prev:hover, .custom-arrow.slick-arrow.slick-next:hover{
      background:#ececec;
    }

    .sigleproduct .fixedbar .requiredcut {
      width: 100% !important;
      margin-right: 0 !important;
      margin-bottom: 22px;
    }
    .basestylecontainer{
      width: 90%;
    }
    .singlecontent .pricesection .samediv .qtypricediscount{width:100%}
    .trim_t_info{width:100%;margin:0}
  }
  @media only screen and (max-width:375px){
    .sigleproduct .fixedbar .samediv.quantity {
      width: 52%;
    }
    .mobile-title h2{
      font-size: 22px;
      line-height: 26px;
    }
    .sigleproduct .fixedbar .ordertype.yard{
      margin-top: -4px;
    }
    .sigleproduct .similarcontent .commonslider .slideimg,
    .sigleproduct .similarcontent .mainproducts .productbox .imgbox,
    .sigleproduct .similarcontent .mainproducts .productbox .imgbox img.proimg{
      max-width: 222px;
      height: 210px;
    }
    .sigleproduct .fixedbar .container{
      padding:0 15px;
    }
    .sigleproduct .fixedbar .beforesignin .btn{
      max-width: 130px;
      min-width: 130px;
    }
  }
  .basestyle-backdrop {
    left: 0;
    z-index: 11;
    width: 100vw;
    opacity: .6;
    position: fixed;
    top: 0;
    height: 100vh;
  }
  .basestylecontainer h3.basecotainertitle {
    font-size: 22px !important;
  }
  .basestylecontainer h3.basefabricname {
    font-size: 16px !important;
  }
  .basestylecontainer p.basefabricdescrip{
    font-size: 12px;
    color:#777;
  }
  .basestylecontainer .fabricSelectBtn{
    width: 100px;
    border-color:#777;
  }
  .basestylecontainer .basestyleaddicon{
    height: 11px;
    width: 11px;
    float: right;
    margin-top: 5px;
  }
  .basestylecontainer .accordion a {
    font-weight: 500;
    font-size: 15px;
    color: #303030;
    width: 100%;
    display: inline-block;
  }

  .pl-65{
    padding-left: 65px !important;
  }

  .basestylecontainer-close-icon{
    width: 13.71px;
    height: 13.71px;
    margin-bottom: 4px;
    cursor: pointer;
  }

  .color-works-image{
    width:80px;
    position: relative;
    bottom: 5px;
  }
</style>